// Do not update. This file is auto-generated. To update, edit the equivalent JS file
// in common/constants and run `make generate-constants` in the root directory.

export const THUMBNAIL_BLOCKED_SOURCES = [];
export const AGENT_EXCLUDED_SOURCE_IDS = [];
export const GEOJSON_EXTENSION = '.geojson';
export const TIF_EXTENSION = '.tif';
export const PNG_EXTENSION = '.png';
export const JPG_EXTENSION = '.jpg';
export const PDF_EXTENSION = '.pdf';
export const GIF_EXTENSION = '.gif';
export const INT_NODATA_VALUE = 0;
export const FLOAT_NODATA_VALUE = -9999;
export const FC_WAITING_FOR_PROCESSING_STATUS = 'waiting-for-processing';
export const FC_WAITING_FOR_UPLOAD_STATUS = 'waiting-for-upload';
export const FC_WAITING_FOR_UPDATE_PROCESSING_STATUS = 'waiting-for-update-processing';
export const FC_PROCESSING_COMPLETE_STATUS = 'complete';
export const FC_FAILED_UPLOAD_STATUS = 'failed';
export const FEATURE_WAITING_FOR_PROCESSING_STATUS = 'waiting-for-processing';
export const FEATURE_PROCESSING_COMPLETE_STATUS = 'complete';
export const FEATURE_DATA_HYDRO_GENERATION_QUANTILES_DATE = '1900-01-01T00:00:00Z';
export const FEATURE_DATA_TIMESTAMP_START_DATE = '1970-01-01T00:00:00Z';
export const FILTER_FIELD_KEY = 'field';
export const FILTER_OPERATION_KEY = 'op';
export const FILTER_VALUE_KEY = 'val';
export const FILTER_TYPE_KEY = 'type';
export const FILTER_OPERATION_EQ = 'eq';
export const FILTER_OPERATION_NOT_EQ = 'not_eq';
export const FILTER_OPERATION_GT = 'gt';
export const FILTER_OPERATION_LT = 'lt';
export const FLOWLINES_FEATURE_COLLECTION_ID = 118;
export const HR_FLOWLINES_FEATURE_COLLECTION_ID = 377;
export const NID_DAMS_FEATURE_COLLECTION_ID = 53;
export const USGS_GAUGES_FEATURE_COLLECTION_ID = 2271;
export const USACE_GAUGES_FEATURE_COLLECTION_ID = 2917;
export const USACE_DRAINAGE_FEATURE_COLLECTION_ID = 2925;
export const DB_PRIVATE_GAUGE_FEATURE_COLLECTION_ID = 2551;
export const RFC_FORECASTS_FEATURE_COLLECTION_ID = 2533;
export const CBRFC_FORECASTS_FEATURE_COLLECTION_ID = 13664;
export const CNRFC_FORECASTS_FEATURE_COLLECTION_ID = 11377;
export const COMPOUND_RFC_FEATURE_COLLECTION_ID = 11784;
export const CO_DWR_GAUGES_FEATURE_COLLECTION_ID = 2932;
export const CO_DWR_DRAINAGE_FEATURE_COLLECTION_ID = 2934;
export const REGRID_FEATURE_COLLECTION_ID = 4153;
export const TRANSMISSION_LINE_FEATURE_COLLECTION_ID = 7882;
export const OVERLAY_MAX_ZOOM_LEVEL = 11;
export const FEATURE_NAME = 'name';
export const MULTIFEATURE_PART_NAME = 'multiFeaturePartName';
export const NOTE_TYPE_USER = 'user';
export const NOTE_TYPE_SYSTEM_NEW_IMAGERY_AVAILABLE = 'system-new-imagery-available';
export const NOTE_TYPE_SYSTEM_NEW_IMAGERY_PROCESSED = 'system-new-imagery-processed';
export const NOTE_TYPE_ALERT = 'alert';
export const NOTE_TYPE_AGENT = 'agent';
export const AGENT_PROMPT_KEY_DESCRIBE = 'describe';
export const AGENT_PROMPT_KEY_IDENTIFY_STRUCTURES = 'identify-structures';
export const AGENT_PROMPT_KEY_FIND_SIMILAR = 'find-similar';
export const AGENT_FEW_SHOT_MAX_EXEMPLARS = 10;
export const AGENT_FEW_SHOT_MAX_LABEL_CHARS = 80;
export const AGENT_FEW_SHOT_MIN_SIDE_PIXELS = 2;
export const AGENT_FEW_SHOT_MAX_AREA_FRACTION = 0.25;
export const AGENT_FEW_SHOT_OVERVIEW_SIZE_CAP = 4096;
export const AGENT_FEW_SHOT_MIN_EXEMPLAR_PX = 12;
export const AGENT_FEW_SHOT_DUPLICATE_IOU = 0.9;
export const AGENT_DEFAULT_RUN_QUOTA = 15;
export const AGENT_OBSERVATION_LIMIT = 100;
export const CUSTOM_ALERT_TYPE_THRESHOLD = 'threshold';
export const CUSTOM_ALERT_TYPE_CATEGORY = 'category';
export const CUSTOM_ALERT_TYPE_VEGETATION_DROP = 'vegetation_drop';
export const CUSTOM_ALERT_TYPE_COMPOSITE = 'composite';
export type CUSTOM_ALERT_TYPES_TYPE = 'threshold' | 'category' | 'vegetation_drop';
export const CUSTOM_ALERT_TYPES: CUSTOM_ALERT_TYPES_TYPE[] = [
  'threshold',
  'category',
  'vegetation_drop',
];
export const THRESHOLD_DIRECTION_ABOVE = 'above';
export const THRESHOLD_DIRECTION_BELOW = 'below';
export const MAX_REGRID_PARCELS_PER_PROPERTY = 500;
export const NOTIFICATION_TYPE_LENS_MONITOR_DATA = 'monitor-data';
export const NOTIFICATION_TYPE_LENS_NOTE = 'note';
export const NOTIFICATION_TYPE_LENS_ALERT = 'alert';
export const NOTIFICATION_TYPE_LENS_IMAGERY_DONE_PROCESSING = 'imagery-done-processing';
export const NOTIFICATION_TYPE_LENS_NEW_IMAGERY_AVAILABLE = 'new-imagery-available';
export const NOTIFICATION_TYPE_LENS_PORTFOLIO_READY = 'portfolio-ready';
export const NOTIFICATION_TYPE_LENS_USER_SIGN_UP = 'user-signup';
export const NOTIFICATION_TYPE_LENS_ACCESS_RENEWAL = 'access-renewal';
export const NOTIFICATION_TYPE_LENS_COG_DOWNLOAD_READY = 'cog-download-ready';
export const NOTIFICATION_TYPE_LENS_REPORT_PDF_EXPORT_READY = 'report-pdf-export-ready';
export const NOTIFICATION_TYPE_HF_NEW_SHORT_TERM_FORECAST = 'new-short-term-forecast';
export const NOTIFICATION_TYPE_HF_FORECAST_THRESHOLD_START = 'forecast-threshold';
export const NOTIFICATION_TYPE_HF_FORECAST_THRESHOLD_END = 'forecast-threshold-end';
export const NOTIFICATION_TYPE_NEW_ORG_MEMBER = 'new-org-member';
export const NOTIFICATION_TYPE_API_KEY_CHANGED = 'api-key-changed';
export const HYDROFORECAST_ALERT_TYPE_THRESHOLD = 'threshold';
export const HYDROFORECAST_ALERT_TYPE_LONG_TERM_AVERAGE_COMPARISON = 'long-term-average-comparison';
export const HYDROFORECAST_ALERT_TYPE_NEW_FORECAST = 'new-forecast';
export const HYDROFORECAST_ALERT_TYPE_UPCOMING_EVENT = 'upcoming-event';
export const NOTIFICATION_DELIVERY_METHOD_EMAIL = 'email';
export const NOTIFICATION_DELIVERY_METHOD_IN_APP = 'in-app';
export const NOTIFICATION_PRIORITY_DIGEST = 'digest';
export const NOTIFICATION_PRIORITY_IMMEDIATE = 'immediate';
export const NOTIFICATION_FREQUENCY_UNSUBSCRIBED = 'unsubscribed';
export const NOTIFICATION_SCOPE_ALL = 'all';
export const NOTIFICATION_SCOPE_MINE = 'mine';
export const NOTIFICATION_SCOPE_NONE = 'none';
export const PROJECT_PRODUCT_MONITORING = 'monitoring';
export type PROJECT_PRODUCTS_TYPE = 'monitoring';
export const PROJECT_PRODUCTS: PROJECT_PRODUCTS_TYPE[] = ['monitoring'];
export const PRODUCT_GEO_FEATURE = 'geofeature';
export const PRODUCT_META = 'meta';
export const PRODUCT_USER_POINT = 'user-point';
export const PRODUCT_USER_POLYGON = 'user-polygon';
export const PRODUCT_USER_LINE = 'user-line';
export const PRODUCT_SYSTEM_POINT = 'system-point';
export const PRODUCT_SYSTEM_POLYGON = 'system-polygon';
export const PRODUCT_SYSTEM_LINE = 'system-line';
export const PRODUCT_VARIANT_BIRD_RETURNS_COMPLIANCE = 'birdreturns-compliance';
export const PRODUCT_VARIANT_HYDRO_DROPS = 'hydro-drops';
export const PRODUCT_VARIANT_USGS = 'usgs';
export const PRODUCT_VARIANT_CA_DWR = 'ca-dwr';
export const PRODUCT_VARIANT_GLOS = 'glos';
export const PRODUCT_VARIANT_FEATURE = 'feature';
export const PRODUCT_LENS = 'lens';
export const PRODUCT_LENS_EXPERIMENTAL = 'lens-experimental';
export const PRODUCT_LENS_NO_SPOT = 'lens-no-spot';
export const PRODUCT_LENS_COMMERCIAL_FREE = 'lens-commercial-free';
export const PRODUCT_LENS_NO_DASHBOARD = 'lens-no-dashboard';
export const PRODUCT_LENS_CARBON = 'lens-carbon';
export const PRODUCT_LENS_CARBON_SPACE_INTELLIGENCE = 'lens-carbon-space-intelligence';
export const PRODUCT_REGRID = 'regrid';
export const PRODUCT_HYDROFORECAST = 'HydroForecast';
export const VIEW_TYPE_AGGREGATE = 'aggregate';
export const VIEW_TYPE_BLOCKS = 'blocks';
export const VIEW_TYPE_MAP = 'map';
export const VIEW_TYPE_TABLE = 'table';
export const VIEW_TYPE_LAYERS = 'layers';
export const VIEW_TYPE_LENS = 'lens';
export const VIEW_TYPE_OVERLAY_METADATA = 'overlay_metadata';
export const VIEW_AGGREGATE_NUMERICAL = 'numerical';
export const VIEW_AGGREGATE_PIE_CHART = 'pieChart';
export const FEATURE_PROPERTY_UNKNOWN = 'Unknown';
export const FEATURE_PROPERTY_UNDETERMINED = 'Undetermined';
export const SMART_COLUMN_AREA = '_smart_area';
export type SCHEMA_GEO_TYPES_TYPE =
  | 'POINT'
  | 'LINE'
  | 'POLYGON'
  | 'ANY'
  | 'MULTIPOLYGON'
  | 'LINESTRING';
export const SCHEMA_GEO_TYPES: SCHEMA_GEO_TYPES_TYPE[] = [
  'POINT',
  'LINE',
  'POLYGON',
  'ANY',
  'MULTIPOLYGON',
  'LINESTRING',
];
export const SCHEMA_VIEWS_FEATURE_TABLE = 'feature-table';
export const SYSTEM_USER_ID = 'system@upstream.tech';
export const SYSTEM_ORGANIZATION_ID = 'system@upstream.tech';
export const LENS_PLAYGROUND_USER_ID = 'lens+playground@upstream.tech';
export const DEMO_ORGANIZATION_ID = 'demo';
export const CHLORIS_ORGANIZATION_ID = 'c2bdc23c-05ac-449e-9d50-04aeabb0d12b';
export const INTERNAL_ORGANIZATION_ID = '-KQ66NhS23Am_QKkk7CR';
export const PLANET_LABS_PBC_ORGANIZATION_ID = '1078146a-7950-4a53-b847-acc15ec458a4';
export const SUPERCRITICAL_ORGANIZATION_ID = '6fffd844-f454-4e24-a07b-e7b4c00d98ef';
export const LENS_PLAYGROUND_ORGANIZATION_ID = 'df88aa75-12da-4687-b933-4813bcd3a57c';
export const TNC_CA_PROPERTY_MONITORING_ORG_ID = 'f52d71db-ce56-43ab-a241-1dbeae199dbf';
export const TNC_ORGS = {
  TNC_CA_PROPERTY_MONITORING_ORG_ID: 'f52d71db-ce56-43ab-a241-1dbeae199dbf',
  TNC_NY_PROPERTY_MONITORING_ORG_ID: '3c93b87d-f766-45ff-897b-5b9d9e9e66e5',
  TNC_TX_PROPERTY_MONITORING_ORG_ID: 'e3ed51c0-4258-40ae-b271-aa4dc9d53f17',
  TNC_MN_PROPERTY_MONITORING_ORG_ID: '60c8a0e0-802c-4b5f-8d9f-c4add61e6a73',
  THE_NATURE_CONSERVANCY_CARIBBEAN: '72e9648d-e5fd-4acf-8b71-d52aa4eea7ff',
  THE_NATURE_CONSERVANCY_DIVISIONAL_PROGRAMS: '532a1f2b-31f1-41dc-855e-d41c6b6c907a',
  THE_NATURE_CONSERVANCY_EMERALD_EDGE: '3b8c5034-4833-4ff4-afd3-cd8ca5942cea',
  THE_NATURE_CONSERVANCY_ILLINOIS: '6f1afaf8-14cf-4783-90cd-0d9a1da4c025',
  THE_NATURE_CONSERVANCY_IN_ALABAMA: '3533185e-649a-4606-b17c-052397a94dfb',
  THE_NATURE_CONSERVANCY_IN_NEW_MEXICO: 'da00281b-3043-4b44-9566-54a570e3d206',
  THE_NATURE_CONSERVANCY_WISCONSIN: 'eb56e008-e8d7-4811-ae4c-fab226d49f02',
  TNC_ARIZONA: '98ac06a0-be67-471b-b48a-86c7a86c3a49',
  TNC_ARKANSAS: '3ca69f1d-5c6c-4f0b-b224-e1c05cecc702',
  TNC_BRAZIL: 'eb010ad2-07c0-47e4-ac95-55c83609c6df',
  TNC_CARBON: 'ed4be3c1-3492-46d1-9ef0-e520fa9444c3',
  TNC_COLORADO: 'ee5ea0c2-6871-450e-8003-970d5cf5cf4f',
  TNC_CONNECTICUT: '5a8c41e4-3dae-4c27-beb7-3f22bd87bf76',
  TNC_FLORIDA: '06b8de4e-a4f0-4a13-82c4-e4fe2cbda47e',
  TNC_GEORGIA: '56703829-d1a1-45d8-91c7-911094b3c20c',
  TNC_HAWAII: '26731f51-bd3c-459c-b428-14eb029a80d6',
  TNC_IDAHO: 'ae9c0343-7ab8-4269-a814-1d4c7d5b73e3',
  TNC_ILLINOS: '6f1afaf8-14cf-4783-90cd-0d9a1da4c025',
  TNC_INDIANA: '3eca5219-ef9d-4302-a31f-4faaa1d99583',
  TNC_KANSAS: 'f63af9c4-73b5-48b7-88c8-a8d4dc1be76b',
  TNC_KENTUCKY: '1fc737c6-858f-4fc7-ac2d-22f56a6a033b',
  TNC_LAMS: '6ac794c8-2a7f-4bc6-ac64-b8a507878024',
  TNC_MAINE: 'b02d1570-3e5e-44f3-9200-d0597190ec6b',
  TNC_MASSACHUSETTS: '769bc4b7-0104-42df-927c-de193565f1cc',
  TNC_MICHIGAN: '24b8e15c-c493-4107-b427-d1ac72325ba6',
  TNC_MINNESOTA_AND_DAKOTAS: '60c8a0e0-802c-4b5f-8d9f-c4add61e6a73',
  TNC_MISSOURI: '1e842b11-c228-4284-9d32-6e40cf4d44a9',
  TNC_MONTANA: 'dd5c930b-43f8-48e8-8e0d-96bad06913e8',
  TNC_NEBRASKA: 'bac2d2ae-d1cf-4f90-b27b-d8ad9674a374',
  TNC_NEVADA: '44c93be6-a130-4153-b853-66089520b813',
  TNC_NEW_HAMPSHIRE: 'ea5671d0-90da-4133-b303-b13b382d3645',
  TNC_NEW_JERSEY: 'b7caea0d-ae24-49ff-92f6-0be5c77c1f85',
  TNC_NORTH_CAROLINA: '270598bc-1c7b-4e26-b034-38ff64f49877',
  TNC_OHIO: '7a44c3fd-cc98-445b-8fb4-ae40db26e4ef',
  TNC_OREGON: '0cfd9beb-49f0-4263-9e02-0566c88cd0a1',
  TNC_PENNSYLVANIA_AND_DELAWARE: 'e0144457-8a6b-478d-804d-5235a829b6c0',
  TNC_SOUTH_AFRICA: '4f27aa9c-81af-4e9a-9d31-ca8a06224169',
  TNC_SOUTH_CAROLINA: '826a1573-c11d-4274-9e7f-aef71ce5165a',
  TNC_TEHACHAPI_REGIONAL_CONSERVATION: 'adb335b5-6fa3-42b6-9cb0-9410e2046e66',
  TNC_TEXAS: 'e3ed51c0-4258-40ae-b271-aa4dc9d53f17',
  TNC_UTAH: '04c82845-3fea-4bc3-8aae-9444a75897fb',
  TNC_VIRGINIA: '71edebc2-aae3-449d-868b-9f5dcdd64020',
  TNC_WASHINGTON: 'c20f09cf-911b-49b1-af60-ad539a9c6414',
  TNC_WV: '105566f8-4452-4de2-b4a5-3f6520d19b97',
  TNC_WYOMING: '02db84e6-c43d-464b-b0f4-7c2e762d0d33',
};
export const USER_SETTINGS_ZOOM_BEHAVIOR = 'zoomBehavior';
export const COMPLIANCE_START_DATE_KEY = 'complianceStartDate';
export const COMPLIANCE_END_DATE_KEY = 'complianceEndDate';
export const USER_ROLE_KEY = 'role';
export const USER_ROLE_OWNER = 'owner';
export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_REGULAR = 'regular';
export const USER_ROLE_READONLY = 'readonly';
export const USER_ROLE_PUBLIC_API_READONLY = 'publicapi_readonly';
export const USER_ROLE_PUBLIC_API_READWRITE = 'publicapi_readwrite';
export const USER_ROLE_INVALID_REQUEST_CODE = 405;
export const SCOPE_PUBLIC_API_READONLY = 'readonly';
export const SCOPE_PUBLIC_API_READWRITE = 'readwrite';
export const SCOPE_PUBLIC_API_STREAMIMAGERY = 'streamimagery';
export const SCOPE_PUBLIC_API_EMAIL_OBSERVATIONS = 'emailobservations';
export type PUBLIC_API_SCOPES_TYPE = 'readonly' | 'readwrite' | 'streamimagery';
export const PUBLIC_API_SCOPES: PUBLIC_API_SCOPES_TYPE[] = [
  'readonly',
  'readwrite',
  'streamimagery',
];
export const ORIGINAL_POLYGON_PROPERTY = 'originalPolygon';
export const META_ORGANIZATION_ID = 'meta@upstream.tech';
export type HTTP_WRITE_METHODS_TYPE = 'POST' | 'PUT' | 'PATCH' | 'DELETE';
export const HTTP_WRITE_METHODS: HTTP_WRITE_METHODS_TYPE[] = ['POST', 'PUT', 'PATCH', 'DELETE'];
export const UNIT_AREA_ACRE = 'areaAcre';
export const UNIT_AREA_KM2 = 'areaKM2';
export const UNIT_AREA_F2 = 'areaF2';
export const UNIT_AREA_M2 = 'areaM2';
export const UNIT_AREA_HECTARE = 'areaHectare';
export const UNIT_CURRENCY_USD = 'currencyUSD';
export const UNIT_ENERGY_KWATTH = 'kwatth';
export const UNIT_ENERGY_KWATTHY = 'kwatthy';
export const UNIT_FLOW_CFS = 'flowcfs';
export const UNIT_FLOW_CMS = 'flowcms';
export const UNIT_LENGTH_FT = 'lengthft';
export const UNIT_LENGTH_IN = 'lengthin';
export const UNIT_LENGTH_KM = 'lengthkm';
export const UNIT_LENGTH_M = 'lengthm';
export const UNIT_PERCENT = 'percent';
export const UNIT_PERCENT_UNIT = 'percentunit';
export const UNIT_POWER_KWATT = 'kwatt';
export const UNIT_SPEED_MPH = 'mi/h';
export const UNIT_SPEED_MS = 'm/s';
export const UNIT_TEMPERATURE_CELSIUS = 'celsius';
export const UNIT_TEMPERATURE_FAHRENHEIT = 'fahrenheit';
export const UNIT_TEMPERATURE_KELVIN = 'kelvin';
export const UNIT_VOLUME_ACREFTY = 'acre-ft/yr';
export const UNIT_VOLUME_ACREFT_ACRE_YEAR = 'acre-ft/acre/yr';
export const UNIT_VOLUME_INDAY = 'in/day';
export const UNIT_VOLUME_KGY = 'kg/yr';
export const UNIT_VOLUME_LBSY = 'lbs/yr';
export const UNIT_VOLUME_LBS_ACRE_YEAR = 'lbs/acre/yr';
export const UNIT_VOLUME_M3 = 'm3';
export const UNIT_VOLUME_MM6HR = 'mm/6hr';
export const UNIT_VOLUME_TONY = 'tons/yr';
export const UNIT_VOLUME_TON_ACRE_YEAR = 'tons/acre/yr';
export type UNITS_TYPE =
  | 'areaAcre'
  | 'areaKM2'
  | 'areaM2'
  | 'areaHectare'
  | 'currencyUSD'
  | 'kwatth'
  | 'kwatthy'
  | 'flowcfs'
  | 'flowcms'
  | 'lengthft'
  | 'lengthin'
  | 'lengthkm'
  | 'lengthm'
  | 'percent'
  | 'percentunit'
  | 'kwatt'
  | 'mi/h'
  | 'm/s'
  | 'celsius'
  | 'fahrenheit'
  | 'kelvin'
  | 'acre-ft/yr'
  | 'acre-ft/acre/yr'
  | 'in/day'
  | 'kg/yr'
  | 'lbs/yr'
  | 'lbs/acre/yr'
  | 'm3'
  | 'mm/6hr'
  | 'tons/yr'
  | 'tons/acre/yr';
export const UNITS: UNITS_TYPE[] = [
  'areaAcre',
  'areaKM2',
  'areaM2',
  'areaHectare',
  'currencyUSD',
  'kwatth',
  'kwatthy',
  'flowcfs',
  'flowcms',
  'lengthft',
  'lengthin',
  'lengthkm',
  'lengthm',
  'percent',
  'percentunit',
  'kwatt',
  'mi/h',
  'm/s',
  'celsius',
  'fahrenheit',
  'kelvin',
  'acre-ft/yr',
  'acre-ft/acre/yr',
  'in/day',
  'kg/yr',
  'lbs/yr',
  'lbs/acre/yr',
  'm3',
  'mm/6hr',
  'tons/yr',
  'tons/acre/yr',
];
export const SYSTEM_PROPERTIES_KEY = '__system';
export const SYSTEM_PROPERTY_PAID_IMAGERY_KEY = 'paidImagery';
export const APP_PROPERTIES_KEY = '__app';
export const APP_PROPERTY_ASSIGNEE_EMAIL = 'assigneeEmail';
export const APP_PROPERTY_ASSIGNEE_EMAILS = 'assigneeEmails';
export const APP_PROPERTY_REPORTING_DUE_DATE = 'reportingDueDate';
export const APP_PROPERTY_TAG_IDS = 'tagIds';
export const APP_PROPERTY_WMTS_URL = 'wmtsUrl';
export const APP_PROPERTY_STREAMIMAGERY_API_KEY = 'streamImageryApiKey';
export const RDM_PROPERTIES_KEY = '__rdm';
export const RDM_PROPERTIES_COMPLIANCE_KEY = 'compliance';
export const ALERT_VEGETATION_DROP_DEFAULT_POLICY_NAME = 'Unseasonal vegetation drop';
export const LEGACY_ALERT_VEGETATION_DROP_ENROLLMENT_KEY = 'processVegetationDrop';
export const ALERT_VEGETATION_DROP_USER_ID = 'vegetation_drop@upstream.tech';
export const ALERT_OWNERSHIP_CHANGE_ENROLLMENT_KEY = 'processOwnershipChange';
export const ALERT_OWNERSHIP_CHANGE_USER_ID = 'ownership_change@upstream.tech';
export const ALERT_OWNERSHIP_CHANGE_PROCESSED_DATE_KEY = '_ownershipChangeProcessedDate';
export const ALERT_PARCEL_INFO_KEY = '_ownershipInfo';
export const ALERT_PARCEL_BOUNDARY_CHANGE_ENROLLMENT_KEY = 'processParcelBoundaryChange';
export const ALERT_PARCEL_BOUNDARY_CHANGE_USER_ID = 'parcel_boundary_change@upstream.tech';
export const ALERT_PARCEL_BOUNDARY_CHANGE_PROCESSED_DATE_KEY = '_boundaryChangeProcessedDate';
export const LENS_AGENT_USER_ID = 'lens-agent@upstream.tech';
export const USER_UPDATED_PROPERTIES_KEY = '__user_updated_properties';
export const PURCHASE_FUNDS_USAGE = 'usage';
export const PURCHASE_FUNDS_VOID = 'void';
export const PURCHASE_FUNDS_REPLACED = 'replaced';
export const PURCHASE_EVENT_PURCHASE = 'purchase';
export const PURCHASE_EVENT_VOID = 'void';
export const PURCHASE_EVENT_SPEND_CREDIT = 'spendCredit';
export const CONTRACT_TYPE_ACRE_UNIT = 'acreUnit';
export const CONTRACT_TYPE_DOLLAR_UNIT = 'dollarUnit';
export const SOURCE_DETAILS_BY_ID = {
  L8: {
    name: 'Landsat 8',
    resolution: 30,
    revisit: 16,
    operator: 'NASA/USGS',
    hq: true,
    copyright_template: 'USGS/NASA Landsat',
    shareable: true,
    downloadable: false,
  },
  S2: {
    name: 'Sentinel-2A/B',
    resolution: 10,
    revisit: 5,
    operator: 'ESA',
    hq: true,
    copyright_template: 'Copernicus Sentinel data <YEAR>',
    shareable: true,
    downloadable: true,
  },
  S1: {
    name: 'Sentinel-1',
    resolution: 20,
    revisit: 6,
    operator: 'ESA',
    hq: false,
    copyright_template: 'Copernicus Sentinel data <YEAR>',
    shareable: true,
    downloadable: false,
  },
  HLS: {
    name: 'Harmonized Landsat Sentinel-2',
    resolution: 30,
    revisit: 3,
    operator: 'NASA/USGS & ESA',
    hq: true,
    copyright_template: 'NASA LP DAAC',
    shareable: true,
    downloadable: true,
  },
  AIRBUS: {
    name: '',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
    downloadable: true,
  },
  'AIRBUS-PLEIADES': {
    name: 'Pléiades',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
    downloadable: true,
  },
  'AIRBUS-PLEIADES-ARCHIVE': {
    name: 'Pléiades, Extended Archive',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
    minimum_order_acres: 100,
    downloadable: true,
  },
  'AIRBUS-PLEIADES-MULTISPECTRAL': {
    name: 'Pléiades, Multispectral',
    resolution: 2,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
    downloadable: true,
    is_multispectral: true,
  },
  'AIRBUS-PLEIADES-ARCHIVE-MULTISPECTRAL': {
    name: 'Pléiades, Extended Archive, Multispectral',
    resolution: 2,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
    minimum_order_acres: 100,
    downloadable: true,
    is_multispectral: true,
  },
  'AIRBUS-PNEO': {
    name: 'Pléiades Neo',
    resolution: 0.3,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
    downloadable: true,
  },
  'AIRBUS-PNEO-ARCHIVE': {
    name: 'Pléiades Neo, Extended Archive',
    resolution: 0.3,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
    minimum_order_acres: 300,
    downloadable: true,
  },
  'AIRBUS-PNEO-MULTISPECTRAL': {
    name: 'Pléiades Neo, Multispectral',
    resolution: 1.2,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
    downloadable: true,
    is_multispectral: true,
  },
  'AIRBUS-PNEO-ARCHIVE-MULTISPECTRAL': {
    name: 'Pléiades Neo, Extended Archive, Multispectral',
    resolution: 1.2,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
    minimum_order_acres: 300,
    downloadable: true,
    is_multispectral: true,
  },
  'AIRBUS-SPOT': {
    name: 'SPOT',
    resolution: 1.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
    downloadable: true,
  },
  'AIRBUS-SPOT-ARCHIVE': {
    name: 'SPOT, Extended Archive',
    resolution: 1.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
    minimum_order_acres: 100,
    downloadable: true,
  },
  'AIRBUS-SPOT-MULTISPECTRAL': {
    name: 'SPOT, Multispectral',
    resolution: 6,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
    downloadable: true,
    is_multispectral: true,
  },
  'AIRBUS-SPOT-ARCHIVE-MULTISPECTRAL': {
    name: 'SPOT, Extended Archive, Multispectral',
    resolution: 6,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
    minimum_order_acres: 100,
    downloadable: true,
    is_multispectral: true,
  },
  'DIGITAL-GLOBE': {
    name: 'WorldView',
    resolution: 0.3,
    revisit: 365,
    operator: 'Vantor',
    hq: true,
    copyright_template: 'Satellite Imagery ©<YEAR> Vantor',
    shareable: false,
    paid: true,
    downloadable: false,
  },
  'DIGITAL-GLOBE-30': {
    name: 'WorldView',
    resolution: 0.3,
    revisit: 365,
    operator: 'Vantor',
    hq: true,
    copyright_template: 'Satellite Imagery ©<YEAR> Vantor',
    shareable: false,
    paid: true,
    downloadable: false,
  },
  'DIGITAL-GLOBE-50': {
    name: 'WorldView',
    resolution: 0.5,
    revisit: 365,
    operator: 'Vantor',
    hq: true,
    copyright_template: 'Satellite Imagery ©<YEAR> Vantor',
    shareable: false,
    paid: true,
    downloadable: false,
  },
  NAIP: {
    name: 'NAIP',
    resolution: 1,
    revisit: 1095,
    operator: 'USDA',
    copyright_template: 'U.S. Department of Agriculture, Farm Service Agency',
    shareable: true,
    downloadable: true,
  },
  NLCD: {
    name: 'Legacy NLCD',
    resolution: 30,
    revisit: 1095,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'NLCD-ANNUAL': {
    name: 'Annual NLCD',
    resolution: 30,
    revisit: 365,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'NLCD-ANNUAL-FIS': {
    name: 'Fractional Impervious Surface',
    resolution: 30,
    revisit: 365,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'USGS-CHEATGRASS': {
    name: 'Cheatgrass',
    resolution: 30,
    revisit: 365,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'ESA-BIOMASS': {
    name: 'Biomass',
    resolution: 100,
    revisit: 365,
    operator: 'ESA',
    shareable: true,
    mosaic_display: 'annual',
    copyright_template: '© ESA Biomass CCI',
    longform_attribution:
      'Santoro, M.; Cartus, O. (2025): ESA Biomass Climate Change Initiative (Biomass_cci): Global datasets of forest above-ground biomass for the years 2007, 2010, 2015, 2016, 2017, 2018, 2019, 2020, 2021 and 2022, v6.0. NERC EDS Centre for Environmental Data Analysis, 17 April 2025. doi:10.5285/95913ffb6467447ca72c4e9d8cf30501.',
    downloadable: true,
  },
  'ESA-WORLDCOVER': {
    name: 'WorldCover',
    resolution: 10,
    revisit: 365,
    operator: 'ESA',
    copyright_template:
      '© ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'PLANET-SKYSAT-COLLECT': {
    name: 'SkySat',
    resolution: 0.5,
    revisit: 365,
    operator: 'Planet',
    hq: true,
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    shareable: true,
    paid: true,
    not_allowed_countries: ['BY', 'CN', 'HK', 'KH', 'MM', 'NI', 'RU', 'VE'],
  },
  'PLANET-BASEMAP': {
    name: 'Mosaic',
    resolution: 4,
    revisit: 30,
    operator: 'Planet',
    hq: true,
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    premium: true,
    billing_intervals: ['month', 'year'],
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AU',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GB',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
    shareable: true,
    mosaic_display: 'monthly_end',
    downloadable: false,
  },
  'PLANET-FOREST-CARBON-30': {
    name: 'Forest Carbon Diligence',
    resolution: 30,
    revisit: 1,
    operator: 'Planet',
    hq: false,
    copyright_template: '<YEAR> Planet Labs PBC',
    shareable: true,
    paid: true,
    mosaic_display: 'annual',
    downloadable: true,
  },
  'PLANET-FOREST-CARBON-3': {
    name: 'Forest Carbon Monitoring',
    resolution: 3,
    revisit: 1,
    operator: 'Planet',
    hq: false,
    copyright_template: '<YEAR> Planet Labs PBC',
    shareable: true,
    paid: true,
    downloadable: true,
  },
  NEARMAP: {
    operator: 'Nearmap',
    name: '',
    resolution: 0.5,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
    downloadable: false,
  },
  'NEARMAP-15': {
    operator: 'Nearmap',
    name: '',
    resolution: 0.15,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
    maximum_order_acres: 1000,
    downloadable: false,
  },
  'NEARMAP-50': {
    operator: 'Nearmap',
    name: '',
    resolution: 0.5,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
    downloadable: false,
  },
  SNODAS: {
    operator: 'National Snow and Ice Data Center',
    name: 'Snow Data Assimilation System',
    resolution: 1000,
    revisit: 1,
    hq: false,
    copyright_template: 'National Operational Hydrologic Remote Sensing Center',
    shareable: true,
    downloadable: false,
  },
  SALO: {
    name: 'Forest Carbon',
    revisit: 365,
    operator: 'Planet',
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    resolution: 10,
    shareable: false,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'SPACE-INTELLIGENCE': {
    name: '',
    resolution: 25,
    revisit: 365,
    operator: 'Space Intelligence',
    copyright_template: '© Space Intelligence. All rights reserved.',
    shareable: false,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'CHLORIS-BIOMASS': {
    name: 'Biomass',
    resolution: 4600,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template:
      'Chloris Geospatial. Creative Commons Attribution Non Commercial Share Alike 4.0 International.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  CHLORIS: {
    name: '',
    resolution: 30,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
    mosaic_display: 'annual',
    downloadable: true,
  },
  'CHLORIS-30': {
    name: '',
    resolution: 30,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    paid: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
    minimum_order_acres: 248,
    mosaic_display: 'annual',
    downloadable: true,
  },
  'CHLORIS-10': {
    name: '',
    resolution: 10,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    paid: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
    minimum_order_acres: 25,
    mosaic_display: 'annual',
    downloadable: true,
  },
  MOBI: {
    name: '',
    resolution: 990,
    revisit: 365,
    operator: 'NatureServe',
    copyright_template: 'NatureServe',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'IMPACT-OBSERVATORY-BIODIVERSITY': {
    operator: 'Impact Observatory and Vizzuality',
    name: '',
    resolution: 100,
    revisit: 365,
    copyright_template:
      'Impact Observatory and Vizzuality. Creative Commons Attribution 4.0 International.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'IMPACT-OBSERVATORY-LANDCOVER': {
    operator: 'Impact Observatory',
    name: '',
    resolution: 10,
    revisit: 365,
    copyright_template: 'Impact Observatory. Creative Commons Attribution 4.0 International.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'IMPACT-OBSERVATORY-HIGH-RES-LANDCOVER': {
    operator: 'Impact Observatory',
    name: '',
    resolution: 10,
    revisit: 365,
    copyright_template: 'Impact Observatory. Creative Commons Attribution 4.0 International.',
    shareable: true,
    downloadable: false,
  },
  'GLOBAL-FOREST-CHANGE': {
    operator: 'University of Maryland GLAD Lab',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'Hansen/UMD/Google/USGS/NASA. Creative Commons Attribution 4.0 International.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'GLOBAL-FOREST-COVER': {
    operator: 'European Commission Joint Research Centre',
    name: 'Global Forest Cover',
    resolution: 10,
    copyright_template: 'EC JRC',
    shareable: true,
    mosaic_display: 'annual',
  },
  'MAPBIOMAS-BRAZIL-LANDCOVER': {
    operator: 'MapBiomas Project',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'MapBiomas Project - Collection 8 of the Annual Series of Land Cover and Use Maps of Brazil.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'MAPBIOMAS-CHACO-LANDCOVER': {
    operator: 'MapBiomas Project',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'MapBiomas Project - Collection 4 of the Annual Series of Land Cover and Use Maps of the Chago Region.',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'MAPBIOMAS-COLOMBIA-LANDCOVER': {
    operator: 'MapBiomas Project',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'MapBiomas Colombia Project - Collection 3 of annual land cover and land use maps',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'WLFW-CO-ISI': {
    operator: 'University of Montana / NRCS',
    name: '',
    resolution: 10,
    revisit: 365,
    copyright_template: 'University of Montana / NRCS',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: true,
  },
  'SBTN-WRINLC': {
    operator: 'World Resources Institute',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template: 'World Resources Institute',
    shareable: true,
    mosaic_display: 'annual',
    downloadable: false,
  },
  'METAWRI-CANOPY-HEIGHT': {
    operator: 'Meta and World Resources Institute',
    name: '',
    resolution: 1,
    revisit: 365,
    copyright_template: 'Meta. Creative Commons Attribution 4.0 International.',
    shareable: true,
    downloadable: true,
  },
  'CTREES-TREE-HEIGHT': {
    operator: 'CTrees',
    name: 'Tree Canopy Height',
    resolution: 0.6,
    revisit: 365,
    copyright_template: '© CTrees',
    shareable: true,
    paid: true,
    mosaic_display: 'annual',
    downloadable: true,
  },
  'TMF-ANNUAL-CHANGE': {
    operator: 'European Commission Joint Research Centre',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template: 'EC JRC',
    shareable: true,
    mosaic_display: 'annual',
  },
  'PRISM-M': {
    operator: 'PRISM Climate Group',
    name: '',
    resolution: 4000,
    revisit: 30,
    copyright_template: 'PRISM Climate Group',
    shareable: false,
    mosaic_display: 'monthly_start',
  },
  'WMTS-TRUECOLOR': {operator: '', name: '', copyright_template: '', shareable: true},
  'WMS-TRUECOLOR': {operator: '', name: '', copyright_template: '', shareable: true},
  'COG-TRUECOLOR': {operator: '', name: '', copyright_template: '', shareable: true},
  'USGS-EAG': {
    name: 'Exotic Annual Grass',
    resolution: 30,
    revisit: 7,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    downloadable: false,
  },
  'RCMAP-WEEKLY': {
    name: 'RCMAP Weekly Herbaceous & Exotic Annual Grass',
    resolution: 30,
    revisit: 7,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
    downloadable: true,
  },
  CDL: {
    operator: 'USDA',
    name: '',
    copyright_template: 'USDA',
    shareable: true,
    downloadable: true,
    mosaic_display: 'annual',
    revisit: 365,
    resolution: 30,
  },
  'WRI-GPWGGC': {
    operator: 'Land & Carbon Lab (via OpenLandMap)',
    name: '',
    copyright_template: 'Land & Carbon Lab (via OpenLandMap)',
    shareable: true,
    downloadable: true,
    mosaic_display: 'annual',
    revisit: 365,
    resolution: 30,
  },
  'GEFS-ANALYSIS-MONTHLY': {
    operator: 'NOAA GEFS from dynamical.org',
    name: '',
    copyright_template:
      'NOAA NWS NCEP GEFS data processed by dynamical.org from NOAA Open Data Dissemination archives.',
    shareable: false,
    mosaic_display: 'monthly_start',
    revisit: 30,
    resolution: 25000,
  },
  'GNATSGO-HYDGRPDCD': {
    operator: 'USDA',
    name: '',
    copyright_template: 'USDA',
    shareable: true,
    downloadable: true,
    resolution: 30,
    revisit: 365,
    mosaic_display: 'annual',
  },
  'GRASSLANDS-RISK': {
    operator: 'US Fish & Wildlife Service',
    name: '',
    copyright_template: 'US Fish & Wildlife Service',
    shareable: true,
    downloadable: true,
    mosaic_display: 'annual',
    revisit: 365,
    resolution: 30,
  },
  'DRONE-DEPLOY': {
    name: '',
    operator: 'DroneDeploy',
    hq: true,
    copyright_template: '© DroneDeploy',
    shareable: false,
    downloadable: false,
  },
};
export type SCENE_PROPERTY_ADDITIONAL_FIELDS_TYPE =
  | 'vendor_name'
  | 'sensor_name'
  | 'copyright'
  | 'cloud_cover_percentage'
  | 'resolution';
export const SCENE_PROPERTY_ADDITIONAL_FIELDS: SCENE_PROPERTY_ADDITIONAL_FIELDS_TYPE[] = [
  'vendor_name',
  'sensor_name',
  'copyright',
  'cloud_cover_percentage',
  'resolution',
];
export const SCENE_PROPERTY_VENDOR_NAME = 'vendor_name';
export const SCENE_PROPERTY_SENSOR_NAME = 'sensor_name';
export const SCENE_PROPERTY_COPYRIGHT_TEXT = 'copyright';
export const SCENE_PROPERTY_CLOUD_COVER_PERCENTAGE = 'cloud_cover_percentage';
export const SCENE_PROPERTY_RESOLUTION = 'resolution';
export const SCENE_PROPERTY_MOSAIC_RANGE = 'mosaic_range';
export type IMAGERY_RESOLUTION_TYPES_TYPE = 'MEDIUM' | 'HIGH';
export const IMAGERY_RESOLUTION_TYPES: IMAGERY_RESOLUTION_TYPES_TYPE[] = ['MEDIUM', 'HIGH'];
export const MEDIUM_RESOLUTION_TYPE = 'MEDIUM';
export const HIGH_RESOLUTION_TYPE = 'HIGH';
export const OAUTH_SCOPE_PROFILE = 'profile';
export const OAUTH_SCOPE_LENS_READ = 'lens:read';
export const OAUTH_SCOPE_LENS_NOTES_WRITE = 'lens:notes:write';
export const OAUTH_SCOPE_LENS_PROPERTIES_WRITE = 'lens:properties:write';
export const OAUTH_SCOPE_LENS_POLICIES_WRITE = 'lens:policies:write';
export const OAUTH_SCOPE_LENS_ALERTS_WRITE = 'lens:alerts:write';
export const OAUTH_SCOPE_LENS_AGENT_RUN = 'lens:agent:run';
export const OAUTH_SCOPE_HYDROFORECAST_READ = 'hydroforecast:read';
export const OAUTH_SCOPE_HYDROFORECAST_OBSERVATIONS_WRITE = 'hydroforecast:observations:write';
export type OAUTH_SCOPES_TYPE =
  | 'profile'
  | 'lens:read'
  | 'lens:notes:write'
  | 'lens:properties:write'
  | 'lens:policies:write'
  | 'lens:alerts:write'
  | 'lens:agent:run'
  | 'hydroforecast:read'
  | 'hydroforecast:observations:write';
export const OAUTH_SCOPES: OAUTH_SCOPES_TYPE[] = [
  'profile',
  'lens:read',
  'lens:notes:write',
  'lens:properties:write',
  'lens:policies:write',
  'lens:alerts:write',
  'lens:agent:run',
  'hydroforecast:read',
  'hydroforecast:observations:write',
];
export type DISABLE_ORDERS_SOURCE_IDS_TYPE = 'PLANET-SKYSAT-COLLECT';
export const DISABLE_ORDERS_SOURCE_IDS: DISABLE_ORDERS_SOURCE_IDS_TYPE[] = [
  'PLANET-SKYSAT-COLLECT',
];
export type BULK_ORDER_SOURCE_IDS_TYPE =
  | 'PLANET-FOREST-CARBON-3'
  | 'PLANET-FOREST-CARBON-30'
  | 'CHLORIS-10'
  | 'CHLORIS-30'
  | 'CTREES-TREE-HEIGHT';
export const BULK_ORDER_SOURCE_IDS: BULK_ORDER_SOURCE_IDS_TYPE[] = [
  'PLANET-FOREST-CARBON-3',
  'PLANET-FOREST-CARBON-30',
  'CHLORIS-10',
  'CHLORIS-30',
  'CTREES-TREE-HEIGHT',
];
export const ORG_PRODUCT_LENS = 'Lens';
export const ORG_PRODUCT_HYDROFORECAST = 'HydroForecast';
export type ORG_PRODUCTS_TYPE = 'Lens' | 'HydroForecast';
export const ORG_PRODUCTS: ORG_PRODUCTS_TYPE[] = ['Lens', 'HydroForecast'];
export const ORG_SETTING_DISPLAY_AREA_UNIT = 'display_area_unit';
export const ORG_SETTING_NOTE_SORT_ORDER = 'note_sort_order';
export const ORG_SETTING_NOTE_DATE_FILTER = 'note_date_filter';
export const ORG_SETTING_VEGETATION_DROP_HOLD_UNTIL_DAY = 'vegetation_drop_hold_until_day';
export const ORG_SETTING_DEFAULT_PROCESSING_PRODUCT = 'default_processing_product';
export const ORG_SETTING_DEFAULT_PAID_SOURCE_PROCESSING_WINDOW =
  'default_paid_source_processing_window';
export const ORG_SETTING_LOGO = 'logo';
export const ORG_SETTING_AUTHENTICATION_CONFIG = 'authentication_config';
export const ORG_SETTING_MFA_REQUIRED = 'mfa_required';
export const ORG_SETTING_AGENT_SETTINGS = 'agent_settings';
export const ORG_SETTING_MCP_DISABLED = 'mcp_disabled';
export const ORG_SETTING_NETWORK_ACCESS = 'network_access';
export const ORG_SETTING_SEASONAL_VOLUME_THRESHOLDS = 'seasonal_volume_thresholds';
export const ORG_SETTING_DEFAULT_BASEMAP = 'default_basemap';
export const ORG_SETTING_SHOW_SMART_SUMMARIES = 'show_smart_summaries';
export const ORG_SETTING_WMTS_ADDITIONAL_SOURCES = 'wmts_additional_sources';
export const ORG_SETTING_SEAT_LIMIT = 'seat_limit';
export const ORG_SETTING_FEATURE_TAGS = 'feature_tags';
export const ORG_SETTING_NOTE_TAGS = 'note_tags';
export type TAG_COLORS_TYPE =
  | '#e23636'
  | '#e29d36'
  | '#d7e236'
  | '#36e245'
  | '#36e2cb'
  | '#3684e2'
  | '#8f36e2'
  | '#e236dd'
  | '#b30000'
  | '#b36b00'
  | '#a7b300'
  | '#00b30f'
  | '#00b39b'
  | '#0050b3'
  | '#5c00b3'
  | '#b300ad'
  | '#ff6666'
  | '#ffc266'
  | '#f5ff66'
  | '#66ff73'
  | '#66ffeb'
  | '#66abff'
  | '#b566ff'
  | '#ff66fa';
export const TAG_COLORS: TAG_COLORS_TYPE[] = [
  '#e23636',
  '#e29d36',
  '#d7e236',
  '#36e245',
  '#36e2cb',
  '#3684e2',
  '#8f36e2',
  '#e236dd',
  '#b30000',
  '#b36b00',
  '#a7b300',
  '#00b30f',
  '#00b39b',
  '#0050b3',
  '#5c00b3',
  '#b300ad',
  '#ff6666',
  '#ffc266',
  '#f5ff66',
  '#66ff73',
  '#66ffeb',
  '#66abff',
  '#b566ff',
  '#ff66fa',
];
export const ORG_SETTING_DEFAULT_REPORT_TEXT = 'default_report_text';
export const ORG_SETTING_OVERVIEW_COLUMN_SETTINGS = 'property_overview_column_settings';
export const ORG_SETTING_IMAGERY_BILLING = 'imagery_billing';
export const IMAGERY_BILLING_INVOICED = 'invoiced';
export const IMAGERY_BILLING_CHECKOUT = 'checkout';
export type IMAGERY_BILLING_MODES_TYPE = 'invoiced' | 'checkout';
export const IMAGERY_BILLING_MODES: IMAGERY_BILLING_MODES_TYPE[] = ['invoiced', 'checkout'];
export type USER_MODIFIABLE_ORG_SETTINGS_TYPE =
  | 'default_basemap'
  | 'property_overview_column_settings'
  | 'show_smart_summaries'
  | 'wmts_additional_sources'
  | 'display_area_unit'
  | 'note_sort_order'
  | 'note_date_filter'
  | 'logo'
  | 'feature_tags'
  | 'note_tags'
  | 'default_report_text'
  | 'mcp_disabled'
  | 'seasonal_volume_thresholds';
export const USER_MODIFIABLE_ORG_SETTINGS: USER_MODIFIABLE_ORG_SETTINGS_TYPE[] = [
  'default_basemap',
  'property_overview_column_settings',
  'show_smart_summaries',
  'wmts_additional_sources',
  'display_area_unit',
  'note_sort_order',
  'note_date_filter',
  'logo',
  'feature_tags',
  'note_tags',
  'default_report_text',
  'mcp_disabled',
  'seasonal_volume_thresholds',
];
export type ORG_SETTING_KEYS_TYPE =
  | 'display_area_unit'
  | 'note_sort_order'
  | 'note_date_filter'
  | 'default_processing_product'
  | 'default_paid_source_processing_window'
  | 'logo'
  | 'authentication_config'
  | 'mfa_required'
  | 'default_basemap'
  | 'property_overview_column_settings'
  | 'vegetation_drop_hold_until_day'
  | 'show_smart_summaries'
  | 'wmts_additional_sources'
  | 'seat_limit'
  | 'feature_tags'
  | 'note_tags'
  | 'default_report_text'
  | 'agent_settings'
  | 'mcp_disabled'
  | 'network_access'
  | 'seasonal_volume_thresholds'
  | 'imagery_billing';
export const ORG_SETTING_KEYS: ORG_SETTING_KEYS_TYPE[] = [
  'display_area_unit',
  'note_sort_order',
  'note_date_filter',
  'default_processing_product',
  'default_paid_source_processing_window',
  'logo',
  'authentication_config',
  'mfa_required',
  'default_basemap',
  'property_overview_column_settings',
  'vegetation_drop_hold_until_day',
  'show_smart_summaries',
  'wmts_additional_sources',
  'seat_limit',
  'feature_tags',
  'note_tags',
  'default_report_text',
  'agent_settings',
  'mcp_disabled',
  'network_access',
  'seasonal_volume_thresholds',
  'imagery_billing',
];
export const ORG_SETTING_PREFIX_HF_FAVORITE_SITES = 'hf_favorite_sites__';
export type ORG_SETTING_KEY_PREFIXES_TYPE = 'hf_favorite_sites__';
export const ORG_SETTING_KEY_PREFIXES: ORG_SETTING_KEY_PREFIXES_TYPE[] = ['hf_favorite_sites__'];
export const SIGNUP_TOKEN_VALIDITY_DAYS = 14;
export const US_CONTIGUOUS_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-66.945392, 24.521208],
      [-66.945392, 49.382808],
      [-124.736342, 49.382808],
      [-124.736342, 24.521208],
      [-66.945392, 24.521208],
    ],
  ],
};
export const US_LOWER_48_SHAPE = {
  type: 'Polygon',
  coordinates: [
    [
      [-123.5746, 48.3268],
      [-123.4433, 48.4637],
      [-123.3534, 48.4214],
      [-123.3044, 48.4368],
      [-123.4219, 48.6716],
      [-123.4566, 48.5623],
      [-123.5502, 48.5265],
      [-123.5495, 48.5851],
      [-123.462, 48.739],
      [-123.4573, 48.7376],
      [-123.4594, 48.7436],
      [-123.4393, 48.7789],
      [-123.4185, 48.7776],
      [-123.4347, 48.7871],
      [-123.3772, 48.8883],
      [-123.3681, 48.8831],
      [-123.3584, 48.886],
      [-123.3762, 48.8899],
      [-123.32, 48.9888],
      [-123.32, 49],
      [-123.3136, 49],
      [-95.16, 49],
      [-95.16, 49.3894],
      [-94.9224, 49.3652],
      [-94.8244, 49.3224],
      [-94.6919, 48.9199],
      [-94.6916, 48.8138],
      [-94.5851, 48.745],
      [-94.2884, 48.7315],
      [-94.229, 48.6719],
      [-93.87, 48.6556],
      [-93.7565, 48.5367],
      [-93.4968, 48.5621],
      [-93.4624, 48.6141],
      [-93.3881, 48.6347],
      [-92.9753, 48.6372],
      [-92.6382, 48.5534],
      [-92.6112, 48.4912],
      [-92.6958, 48.4651],
      [-92.4787, 48.4491],
      [-92.4436, 48.337],
      [-92.3652, 48.2427],
      [-92.3115, 48.2587],
      [-92.3226, 48.3151],
      [-92.2902, 48.3498],
      [-92.0659, 48.3662],
      [-91.9657, 48.2541],
      [-91.735, 48.1974],
      [-91.678, 48.1473],
      [-91.6862, 48.1174],
      [-91.5828, 48.1071],
      [-91.5599, 48.0691],
      [-91.2815, 48.0844],
      [-90.873, 48.2543],
      [-90.825, 48.2326],
      [-90.828, 48.1913],
      [-90.7461, 48.104],
      [-90.1182, 48.1352],
      [-89.916, 48.0071],
      [-89.7634, 48.0373],
      [-89.3652, 47.9997],
      [-88.6485, 48.2757],
      [-88.3721, 48.3246],
      [-84.8706, 46.9162],
      [-84.7578, 46.6465],
      [-84.5581, 46.4795],
      [-84.5006, 46.4753],
      [-84.3929, 46.54],
      [-84.3048, 46.5233],
      [-84.1973, 46.5664],
      [-84.1012, 46.5442],
      [-84.1372, 46.4316],
      [-84.0865, 46.3541],
      [-84.0776, 46.2307],
      [-83.956, 46.0821],
      [-83.8433, 46.1388],
      [-83.6105, 46.1353],
      [-83.4467, 46.0196],
      [-83.5943, 45.7934],
      [-83.4758, 45.7902],
      [-82.5335, 45.348],
      [-82.126, 43.5725],
      [-82.3918, 43.045],
      [-82.5096, 42.6088],
      [-82.8224, 42.3809],
      [-83.0668, 42.2898],
      [-83.1095, 42.2329],
      [-83.1393, 42.0441],
      [-83.0569, 41.8644],
      [-82.7044, 41.6992],
      [-82.4533, 41.6919],
      [-81.2833, 42.2275],
      [-80.2515, 42.385],
      [-79.0284, 42.8207],
      [-78.9299, 42.9291],
      [-79.0502, 43.0052],
      [-79.0432, 43.0506],
      [-79.0851, 43.1031],
      [-79.0772, 43.2706],
      [-79.193, 43.4716],
      [-78.7576, 43.6359],
      [-76.8099, 43.6615],
      [-76.4669, 44.1],
      [-76.3375, 44.199],
      [-76.197, 44.2427],
      [-76.1591, 44.3222],
      [-75.8805, 44.4264],
      [-75.7123, 44.5972],
      [-75.2812, 44.8805],
      [-74.9085, 45.0246],
      [-74.7196, 45.0192],
      [-74.5398, 45.1067],
      [-74.4645, 45.1927],
      [-74.2183, 45.2842],
      [-74.1622, 45.338],
      [-73.9965, 45.3591],
      [-74.0223, 45.3995],
      [-73.6833, 45.4014],
      [-73.7279, 45.3993],
      [-73.9967, 45.2267],
      [-74.321, 45.1597],
      [-74.426, 45.0695],
      [-74.5567, 45.0187],
      [-71.5264, 45.0336],
      [-71.4302, 45.1978],
      [-71.4654, 45.2384],
      [-71.3408, 45.3076],
      [-71.1627, 45.2662],
      [-70.9905, 45.3677],
      [-70.9369, 45.3456],
      [-70.8911, 45.2592],
      [-70.8239, 45.4402],
      [-70.6654, 45.4128],
      [-70.7516, 45.4874],
      [-70.7022, 45.5855],
      [-70.5828, 45.6794],
      [-70.4324, 45.7325],
      [-70.4306, 45.8172],
      [-70.2811, 45.9311],
      [-70.3363, 45.9822],
      [-70.3309, 46.0877],
      [-70.2646, 46.1413],
      [-70.3, 46.2177],
      [-70.2029, 46.3722],
      [-70.0897, 46.4337],
      [-70.0233, 46.7167],
      [-69.2817, 47.454],
      [-69.2231, 47.4797],
      [-69.0566, 47.447],
      [-69.0394, 47.2791],
      [-68.9023, 47.2103],
      [-68.6499, 47.2649],
      [-68.5224, 47.3243],
      [-68.4046, 47.3187],
      [-68.3595, 47.3747],
      [-68.297, 47.3877],
      [-68.1879, 47.3592],
      [-67.9831, 47.2405],
      [-67.7985, 47.0951],
      [-67.7646, 45.9622],
      [-67.7379, 45.9197],
      [-67.7763, 45.872],
      [-67.7528, 45.8273],
      [-67.7874, 45.7186],
      [-67.6027, 45.6395],
      [-67.4158, 45.6106],
      [-67.4078, 45.5256],
      [-67.4697, 45.4838],
      [-67.4088, 45.388],
      [-67.4543, 45.2814],
      [-67.3467, 45.1838],
      [-67.259, 45.2246],
      [-67.2097, 45.2106],
      [-67.188, 45.2531],
      [-67.1252, 45.2174],
      [-67.0675, 45.1087],
      [-67.0342, 45.1835],
      [-66.9426, 45.2097],
      [-66.8304, 45.138],
      [-66.8791, 45.0852],
      [-66.8016, 45.1278],
      [-66.7654, 45.0809],
      [-66.7538, 45.0913],
      [-66.5915, 44.8476],
      [-66.7478, 44.6793],
      [-66.781, 44.7772],
      [-66.8334, 44.7449],
      [-66.8714, 44.6531],
      [-66.7517, 44.675],
      [-67.179, 44.2149],
      [-70.2779, 42.9973],
      [-70.3584, 42.4736],
      [-69.5726, 42.0079],
      [-69.8522, 40.8663],
      [-71.1229, 41.1254],
      [-73.5915, 40.1843],
      [-75.5595, 36.8905],
      [-75.1826, 35.0378],
      [-78.4974, 33.4892],
      [-80.7542, 31.5351],
      [-80.9973, 30.3643],
      [-79.6784, 27.021],
      [-79.7294, 25.7535],
      [-80.2, 24.9974],
      [-80.2, 24.4],
      [-81.0751, 24.4],
      [-82.1251, 24.1658],
      [-82.2327, 24.4],
      [-83.1, 24.4],
      [-83.1, 25.4],
      [-81.5801, 25.4],
      [-83.0778, 27.3125],
      [-83.0874, 28.7703],
      [-84.0542, 29.6547],
      [-85.0472, 29.2059],
      [-86.4314, 29.9854],
      [-88.326, 29.8583],
      [-89.3146, 28.5408],
      [-93.9894, 29.2831],
      [-96.7647, 27.6467],
      [-96.7471, 25.887],
      [-97.3521, 25.5261],
      [-97.2625, 25.7969],
      [-99.1736, 26.349],
      [-99.5549, 27.0206],
      [-99.609, 27.5255],
      [-100.3563, 28.2189],
      [-100.87, 29.1849],
      [-101.476, 29.6757],
      [-102.2926, 29.7632],
      [-102.62, 29.6455],
      [-102.7891, 29.1574],
      [-103.0817, 28.9053],
      [-103.3196, 28.904],
      [-104.5129, 29.5167],
      [-104.9817, 30.5115],
      [-106.4418, 31.6572],
      [-106.53, 31.6583],
      [-106.53, 31.7833],
      [-108.2, 31.7833],
      [-108.2, 31.3333],
      [-111.0742, 31.3333],
      [-111.0742, 31.2453],
      [-114.8526, 32.405],
      [-114.9025, 32.5991],
      [-116.9952, 32.4408],
      [-116.7512, 32.1587],
      [-117.0968, 32.1327],
      [-117.9934, 33.1866],
      [-118.4741, 32.4054],
      [-119.0075, 33.0393],
      [-118.7944, 33.6711],
      [-119.4071, 33.6466],
      [-119.1783, 32.9166],
      [-119.776, 32.9053],
      [-119.7245, 33.5013],
      [-120.7964, 33.8371],
      [-121.0367, 34.8533],
      [-124.0578, 38.7078],
      [-124.7811, 40.2964],
      [-124.4719, 41.4306],
      [-124.9142, 42.6859],
      [-124.3254, 45.9556],
      [-125.0814, 48.2802],
      [-124.8471, 48.6611],
      [-124.6603, 48.5927],
      [-124.491, 48.5621],
      [-124.3954, 48.5843],
      [-124.3708, 48.5623],
      [-124.3913, 48.5382],
      [-123.6533, 48.3347],
      [-123.5746, 48.3268],
    ],
  ],
};
export const US_AK_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-187.538333, 51.219862],
      [-129.980058, 51.219862],
      [-129.980058, 71.352561],
      [-187.538333, 71.352561],
      [-187.538333, 51.219862],
    ],
  ],
};
export const US_HI_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-160.555771, 18.917466],
      [-154.809379, 18.917466],
      [-154.809379, 22.23317],
      [-160.555771, 22.23317],
      [-160.555771, 18.917466],
    ],
  ],
};
export const US_PR_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-67.954119, 17.884813],
      [-65.22111, 17.884813],
      [-65.22111, 18.515757],
      [-67.954119, 18.515757],
      [-67.954119, 17.884813],
    ],
  ],
};
export const US_USVI_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-65.25, 17.55],
      [-64.35, 17.55],
      [-64.35, 18.45],
      [-65.25, 18.45],
      [-65.25, 17.55],
    ],
  ],
};
export const US_GUAM_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [144.545, 13.145],
      [145.055, 13.145],
      [145.055, 13.755],
      [144.545, 13.755],
      [144.545, 13.145],
    ],
  ],
};
export const US_CNMI_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [144.85, 14.05],
      [146.15, 14.05],
      [146.15, 20.65],
      [144.85, 20.65],
      [144.85, 14.05],
    ],
  ],
};
export const BRAZIL_SHAPE = {
  type: 'Polygon',
  coordinates: [
    [
      [-66.73868763191244, 3.817727302365795],
      [-66.76492270794989, 3.8920935101043055],
      [-65.28075854617934, 6.206433354549793],
      [-60.85608179904895, 6.821899895754845],
      [-56.34706239461037, 4.433440259337895],
      [-53.22849792243042, 5.34847040816386],
      [-49.54341285586391, 5.125052862587175],
      [-49.1610224696129, 3.772118293490612],
      [-45.494097642314856, 0.8540762923100035],
      [-43.167764162704295, -0.253086241407905],
      [-39.84749187667955, -0.8522552236794818],
      [-37.357660673882265, -2.1657232486481],
      [-34.15792124794975, -4.282495836303781],
      [-33.03653022357906, -6.97749581185895],
      [-33.0929757997198, -8.637809217421603],
      [-34.2530476309725, -10.965928428458733],
      [-35.80024094566871, -12.864583596808126],
      [-36.9989310827132, -16.33539479425263],
      [-38.07786739482119, -20.2702666191586],
      [-42.608043657866865, -24.5381661881276],
      [-46.236395068296986, -26.37392450849916],
      [-46.46942276715549, -28.440815885322195],
      [-50.005247447210614, -32.99588814944223],
      [-54.4102572857727, -33.71551697388108],
      [-57.93766764241119, -31.608869439694164],
      [-57.85062177478954, -27.783620480378982],
      [-57.56205361384025, -27.266208197106657],
      [-57.78404495513337, -23.303990461102543],
      [-59.66079598586483, -20.91168223658777],
      [-61.74832762126287, -17.251210757064356],
      [-61.93144556744948, -16.809425519632185],
      [-65.23950069492332, -14.122295275327359],
      [-65.92893100332086, -13.596217034573508],
      [-72.33446033772208, -11.977998302285295],
      [-75.38561109034882, -8.978126422271606],
      [-75.81701380754065, -7.866079615572957],
      [-73.61959291201032, -3.4927494889299666],
      [-72.04473692551578, 0.16965109068903655],
      [-69.1406604253911, 3.390085970939774],
      [-66.73868763191244, 3.817727302365795],
    ],
  ],
};
export const CHACO_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-71.5734499, -14.5497432],
      [-71.5734499, -35.7004867],
      [-53.9118528, -35.7004867],
      [-53.9118528, -14.5497432],
      [-71.5734499, -14.5497432],
    ],
  ],
};
export const RCMAP_WESTERN_NA_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-128.5, 23.2],
      [-128.5, 52.5],
      [-87.5, 52.5],
      [-87.5, 23.2],
      [-128.5, 23.2],
    ],
  ],
};
export const COLOMBIA_SHAPE = {
  type: 'MultiPolygon',
  coordinates: [
    [
      [
        [-75.37322, -0.15203],
        [-76.29231, 0.41605],
        [-76.57638, 0.25694],
        [-77.42498, 0.39569],
        [-77.66861, 0.82589],
        [-77.85506, 0.80993],
        [-78.85526, 1.38092],
        [-78.99093, 1.69137],
        [-78.61783, 1.7664],
        [-78.66212, 2.26735],
        [-78.42761, 2.62956],
        [-77.93154, 2.69661],
        [-77.12769, 3.84964],
        [-77.49627, 4.08761],
        [-77.3076, 4.66798],
        [-77.53322, 5.58281],
        [-77.31882, 5.84535],
        [-77.47666, 6.69112],
        [-77.88157, 7.22377],
        [-77.75341, 7.70984],
        [-77.43111, 7.63806],
        [-77.24257, 7.93528],
        [-77.47472, 8.52429],
        [-77.35336, 8.67051],
        [-76.83667, 8.63875],
        [-76.08638, 9.33682],
        [-75.6746, 9.44325],
        [-75.6647, 9.774],
        [-75.48043, 10.61899],
        [-74.9069, 11.08305],
        [-74.27675, 11.10204],
        [-74.19722, 11.31047],
        [-73.41476, 11.22701],
        [-72.2382, 11.95555],
        [-71.75409, 12.4373],
        [-71.39982, 12.37604],
        [-71.13746, 12.11298],
        [-71.33158, 11.77628],
        [-71.97392, 11.60867],
        [-72.22758, 11.1087],
        [-72.61466, 10.82198],
        [-72.90529, 10.45034],
        [-73.0276, 9.73677],
        [-73.30495, 9.152],
        [-72.78873, 9.08503],
        [-72.66049, 8.62529],
        [-72.43986, 8.40527],
        [-72.3609, 8.00264],
        [-72.47968, 7.63251],
        [-72.44449, 7.42378],
        [-72.19835, 7.34043],
        [-71.96018, 6.99162],
        [-70.67423, 7.08779],
        [-70.09331, 6.96038],
        [-69.38948, 6.09986],
        [-68.98532, 6.20681],
        [-68.26505, 6.15327],
        [-67.69509, 6.26732],
        [-67.34144, 6.09547],
        [-67.52153, 5.55687],
        [-67.7447, 5.22113],
        [-67.82301, 4.50394],
        [-67.62184, 3.83948],
        [-67.33756, 3.54234],
        [-67.30317, 3.31845],
        [-67.80994, 2.82065],
        [-67.44709, 2.60028],
        [-67.18129, 2.25064],
        [-66.87633, 1.25336],
        [-67.06505, 1.13011],
        [-67.26, 1.72],
        [-67.53781, 2.03716],
        [-67.86857, 1.69246],
        [-69.81697, 1.7148],
        [-69.8046, 1.08908],
        [-69.21864, 0.98568],
        [-69.25243, 0.60265],
        [-69.4524, 0.70616],
        [-70.01557, 0.54141],
        [-70.02066, -0.18516],
        [-69.57707, -0.54999],
        [-69.42049, -1.12262],
        [-69.4441, -1.55629],
        [-69.89364, -4.29819],
        [-70.39404, -3.76659],
        [-70.69268, -3.74287],
        [-70.04771, -2.72516],
        [-70.81348, -2.25686],
        [-71.41365, -2.3428],
        [-71.77476, -2.16979],
        [-72.32579, -2.43422],
        [-73.07039, -2.30895],
        [-73.6595, -1.26049],
        [-74.12239, -1.00283],
        [-74.4416, -0.53082],
        [-75.10662, -0.0572],
        [-75.37322, -0.15203],
      ],
    ],
    [
      [
        [-81.3, 12.45],
        [-81.3, 13.45],
        [-81.8, 13.45],
        [-81.8, 12.45],
        [-81.3, 12.45],
      ],
    ],
    [
      [
        [-81.55, 3.95],
        [-81.55, 4.05],
        [-81.66, 4.05],
        [-81.66, 3.95],
        [-81.55, 3.95],
      ],
    ],
    [
      [
        [-78.08, 2.9],
        [-78.08, 3.02],
        [-78.22, 3.02],
        [-78.22, 2.9],
        [-78.08, 2.9],
      ],
    ],
  ],
};
export const COLORADO_SHAPE = {
  type: 'Polygon',
  coordinates: [
    [
      [-109.0501, 41.0006],
      [-106.8615, 41.0028],
      [-104.0532, 41.0034],
      [-102.0517, 41.0028],
      [-102.0454, 38.6953],
      [-102.0418, 37.7349],
      [-102.0418, 36.9931],
      [-103.0023, 36.9991],
      [-105.9985, 36.9952],
      [-108.0001, 36.9991],
      [-109.0453, 36.9991],
      [-109.0464, 38.275],
      [-109.0512, 39.4951],
      [-109.0501, 41.0006],
    ],
  ],
};
export const LENS_TIER_FOCUS = 'lens-focus';
export const LENS_TIER_PLUS = 'lens-plus';
export const LENS_TIER_ENTERPRISE = 'lens-enterprise';
export type LENS_TIERS_TYPE = 'lens-focus' | 'lens-plus' | 'lens-enterprise';
export const LENS_TIERS: LENS_TIERS_TYPE[] = ['lens-focus', 'lens-plus', 'lens-enterprise'];
export const LENS_TIER_SETTINGS = {
  'lens-focus': {name: 'Lens Standard', seatLimit: 10},
  'lens-plus': {name: 'Lens Standard', seatLimit: 10},
  'lens-enterprise': {name: 'Lens Enterprise', seatLimit: null},
};
export const LENS_ACCESS_SUBSCRIPTION_FOCUS = 'focus_annual';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_MONTHLY = 'focus_monthly';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_NGO = 'focus_ngo_annual';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_NGO_MONTHLY = 'focus_ngo_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS = 'plus_annual';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_MONTHLY = 'plus_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_NGO = 'plus_ngo_annual';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_NGO_MONTHLY = 'plus_ngo_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_ENTERPRISE_MEMBER = 'plus_enterprise_member';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_DEMO = 'plus_demo';
export const LENS_ACCESS_SUBSCRIPTION_ENTERPRISE = 'enterprise';
export type LENS_ACCESS_SUBSCRIPTIONS_TYPE =
  | 'focus_annual'
  | 'focus_monthly'
  | 'focus_ngo_annual'
  | 'focus_ngo_monthly'
  | 'plus_annual'
  | 'plus_monthly'
  | 'plus_ngo_annual'
  | 'plus_ngo_monthly'
  | 'plus_enterprise_member'
  | 'plus_demo'
  | 'enterprise';
export const LENS_ACCESS_SUBSCRIPTIONS: LENS_ACCESS_SUBSCRIPTIONS_TYPE[] = [
  'focus_annual',
  'focus_monthly',
  'focus_ngo_annual',
  'focus_ngo_monthly',
  'plus_annual',
  'plus_monthly',
  'plus_ngo_annual',
  'plus_ngo_monthly',
  'plus_enterprise_member',
  'plus_demo',
  'enterprise',
];
export const LIVE_LENS_PUBLIC_IMAGERY_PRODUCT_ID = 'prod_R4xS7V6kloODmz';
export const TEST_LENS_PUBLIC_IMAGERY_PRODUCT_ID = 'prod_R4xjs3hvNg19Pd';
export const LENS_ADDON_STORAGE = 'storage';
export type LENS_ADDONS_TYPE = 'storage';
export const LENS_ADDONS: LENS_ADDONS_TYPE[] = ['storage'];
export const LENS_ACCESS_SUBSCRIPTION_SIGNUP_OPTIONS = {
  focus_annual: {name: 'Lens Lite'},
  focus_monthly: {name: 'Lens Lite'},
  plus_annual: {name: 'Lens Standard'},
  plus_monthly: {name: 'Lens Standard'},
};
export const LENS_BUNDLE_SIGNUP_OPTIONS = {
  planet_basemaps_monthly: {
    display: 'Planet Mosaics',
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AU',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GB',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
  },
  planet_basemaps_annual: {
    display: 'Planet Mosaics',
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AU',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GB',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
  },
};
export const LENS_MAX_CHECKOUT_ITEMS = 240;
export const LENS_PREPAID_PURCHASE_MIN_CENTS = 100;
export const LENS_FEATURE_IMAGE_COLLECTION_BOUNDS_SOURCE_ID_KEY = '_bounds_source_id';
export const LENS_WINDOW_GEOMETRY_SOURCE_ID_KEY_SUFFIX = 'window-geometry-bounds';
export const ESA_WORLDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'Unknown'},
  '10': {color: '#006400', label: 'Trees'},
  '20': {color: '#ffbb22', label: 'Shrubland'},
  '30': {color: '#ffff4c', label: 'Grassland'},
  '40': {color: '#f096ff', label: 'Cropland'},
  '50': {color: '#fa0000', label: 'Built-up'},
  '60': {color: '#b4b4b4', label: 'Barren / sparse vegetation'},
  '70': {color: '#f0f0f0', label: 'Snow and ice'},
  '80': {color: '#0064c8', label: 'Open water'},
  '90': {color: '#0096a0', label: 'Herbaceous wetland'},
  '95': {color: '#00cf75', label: 'Mangroves'},
  '100': {color: '#fae6a0', label: 'Moss and lichen'},
};
export const GLOBAL_FOREST_CHANGE_LOSSYEAR_VALUE_MAP = {
  '0': {color: '#E0E0E0', label: 'No Loss', order: 1},
  '1': {color: '#67001f', label: 'Forest Loss', order: 0},
};
export const GLOBAL_FOREST_COVER_FORESTCOVER_VALUE_MAP = {
  '0': {color: '#ffffff', label: 'Non-forest', order: 1},
  '1': {color: '#4d9221', label: 'Forest', order: 0},
};
export const TMF_ANNUAL_CHANGE_VALUE_MAP = {
  '1': {color: '#005A00', label: 'Undisturbed tropical moist forest'},
  '2': {color: '#649B23', label: 'Degraded tropical moist forest'},
  '3': {color: '#FF870F', label: 'Deforested land'},
  '4': {color: '#D2FA3C', label: 'Tropical moist forest regrowth'},
  '5': {color: '#008CBE', label: 'Permanent and seasonal water'},
  '6': {color: '#FFFFFF', label: 'Other land cover'},
};
export const NLCD_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'Unknown'},
  '1': {color: '#5475A8', label: 'Open Water'},
  '2': {color: '#ffffff', label: 'Perennial Ice/Snow'},
  '3': {color: '#E8D1D1', label: 'Developed, Open Space'},
  '4': {color: '#E29E8C', label: 'Developed, Low Intensity'},
  '5': {color: '#ff0000', label: 'Developed, Medium Intensity'},
  '6': {color: '#B50000', label: 'Developed High Intensity'},
  '7': {color: '#D2CDC0', label: 'Barren Land (Rock/Sand/Clay)'},
  '8': {color: '#85C77E', label: 'Deciduous Forest'},
  '9': {color: '#38814E', label: 'Evergreen Forest'},
  '10': {color: '#D4E7B0', label: 'Mixed Forest'},
  '11': {color: '#AF963C', label: 'Dwarf Scrub'},
  '12': {color: '#DCCA8F', label: 'Shrub/Scrub'},
  '13': {color: '#FDE9AA', label: 'Grassland/Herbaceous'},
  '14': {color: '#D1D182', label: 'Sedge/Herbaceous'},
  '15': {color: '#A3CC51', label: 'Lichens'},
  '16': {color: '#82BA9E', label: 'Moss'},
  '17': {color: '#FBF65D', label: 'Pasture/Hay'},
  '18': {color: '#CA9146', label: 'Cultivated Crops'},
  '19': {color: '#C8E6F8', label: 'Woody Wetlands'},
  '20': {color: '#64B3D5', label: 'Emergent Herbaceous Wetlands'},
};
export const NLCD_ANNUAL_LANDCOVER_VALUE_MAP = {
  '11': {color: '#466B9F', label: 'Open Water'},
  '12': {color: '#D1DEF8', label: 'Perennial Ice/Snow'},
  '21': {color: '#DEC5C5', label: 'Developed, Open Space'},
  '22': {color: '#D99282', label: 'Developed, Low Intensity'},
  '23': {color: '#EB0000', label: 'Developed, Medium Intensity'},
  '24': {color: '#AB0000', label: 'Developed, High Intensity'},
  '31': {color: '#B3AC9F', label: 'Barren Land'},
  '41': {color: '#68AB5F', label: 'Deciduous Forest'},
  '42': {color: '#1C5F2C', label: 'Evergreen Forest'},
  '43': {color: '#B5C58F', label: 'Mixed Forest'},
  '52': {color: '#CCB879', label: 'Shrub/Scrub'},
  '71': {color: '#DFDFC2', label: 'Grassland/Herbaceous'},
  '81': {color: '#DCD939', label: 'Pasture/Hay'},
  '82': {color: '#AB6C28', label: 'Cultivated Crops'},
  '90': {color: '#B8D9EB', label: 'Woody Wetlands'},
  '95': {color: '#6C9FB8', label: 'Emergent Herbaceous Wetlands'},
};
export const MAPBIOMAS_BRAZIL_LANDCOVER_VALUE_MAP = {
  '1': {color: '#32a65e', label: 'Forest'},
  '3': {color: '#1f8d49', label: 'Forest Formation'},
  '4': {color: '#7dc975', label: 'Savanna Formation'},
  '5': {color: '#04381d', label: 'Mangrove'},
  '6': {color: '#026975', label: 'Floodable Forest'},
  '9': {color: '#7a5900', label: 'Forest Plantation'},
  '10': {color: '#ad975a', label: 'Herbaceous and Shrubby Vegetation'},
  '11': {color: '#519799', label: 'Wetland'},
  '12': {color: '#d6bc74', label: 'Grassland'},
  '14': {color: '#FFFFB2', label: 'Farming'},
  '15': {color: '#edde8e', label: 'Pasture'},
  '18': {color: '#E974ED', label: 'Agriculture'},
  '19': {color: '#C27BA0', label: 'Temporary Crop'},
  '20': {color: '#db7093', label: 'Sugar cane'},
  '21': {color: '#ffefc3', label: 'Mosaic of Uses'},
  '22': {color: '#d4271e', label: 'Non vegetated area'},
  '23': {color: '#ffa07a', label: 'Beach'},
  '24': {color: '#d4271e', label: 'Urban Area'},
  '25': {color: '#db4d4f', label: 'Other non Vegetated Areas'},
  '26': {color: '#0000FF', label: 'Water'},
  '27': {color: '#ffffff', label: 'Not Observed'},
  '29': {color: '#ffaa5f', label: 'Rocky Outcrop'},
  '30': {color: '#9c0027', label: 'Mining'},
  '31': {color: '#091077', label: 'Aquaculture'},
  '32': {color: '#fc8114', label: 'Hypersaline Tidal Flat'},
  '33': {color: '#2532e4', label: 'River'},
  '35': {color: '#9065d0', label: 'Palm Oil'},
  '36': {color: '#d082de', label: 'Perennial Crop'},
  '39': {color: '#f5b3c8', label: 'Soybean'},
  '40': {color: '#c71585', label: 'Rice'},
  '41': {color: '#f54ca9', label: 'Other Temporary Crops'},
  '46': {color: '#d68fe2', label: 'Coffee'},
  '47': {color: '#9932cc', label: 'Citrus'},
  '48': {color: '#e6ccff', label: 'Other Perennial Crops'},
  '49': {color: '#02d659', label: 'Wooded Sandbank Vegetation'},
  '50': {color: '#ad5100', label: 'Herbaceous Sandbank Vegetation'},
  '62': {color: '#ff69b4', label: 'Cotton (beta)'},
};
export const MAPBIOMAS_CHACO_LANDCOVER_VALUE_MAP = {
  '1': {color: '#1f8d49', label: 'Natural wooded vegetation'},
  '3': {color: '#1f8d49', label: 'Closed woodland'},
  '4': {color: '#7dc975', label: 'Open woodland'},
  '6': {color: '#007785', label: 'Flooded woodland'},
  '9': {color: '#7a5900', label: 'Forest plantation'},
  '10': {color: '#d6bc74', label: 'Natural non-wooded vegetation'},
  '11': {color: '#519799', label: 'Flooded Grassland'},
  '12': {color: '#d6bc74', label: 'Grassland'},
  '14': {color: '#ffefc3', label: 'Agricultural and livestock areas'},
  '15': {color: '#edde8e', label: 'Pasture'},
  '18': {color: '#e974ed', label: 'Agriculture'},
  '19': {color: '#d5a6bd', label: 'Annual Crops'},
  '22': {color: '#d4271e', label: 'Non-vegetated area'},
  '23': {color: '#ffa07a', label: 'Beach, Dune and Sand Spot'},
  '24': {color: '#d4271e', label: 'Urban Area'},
  '25': {color: '#db4d4f', label: 'Other non Vegetated Areas'},
  '26': {color: '#2532e4', label: 'Water bodies'},
  '27': {color: '#ffffff', label: 'Not observed'},
  '36': {color: '#d082de', label: 'Shrub plantation'},
  '42': {color: '#a5b35b', label: 'Open Grassland'},
  '43': {color: '#c2d26b', label: 'Closed Grassland'},
  '44': {color: '#cbe286', label: 'Sparse Grassland'},
  '45': {color: '#807a40', label: 'Sparse woodland'},
  '57': {color: '#f99fff', label: 'Single crop'},
  '58': {color: '#d84690', label: 'Multiple crop'},
  '61': {color: '#f5d5d5', label: 'Salt Flat'},
};
export const MAPBIOMAS_COLOMBIA_LANDCOVER_VALUE_MAP = {
  '3': {color: '#1f8d49', label: 'Forest'},
  '5': {color: '#04381d', label: 'Mangrove'},
  '6': {color: '#026975', label: 'Flooded Forest'},
  '9': {color: '#7a5900', label: 'Forest Plantation'},
  '11': {color: '#519799', label: 'Wetland'},
  '12': {color: '#d6bc74', label: 'Grassland'},
  '13': {color: '#d89f5c', label: 'Other Non-Forest Formation'},
  '21': {color: '#ffefc3', label: 'Mosaic of Agriculture and Pasture'},
  '23': {color: '#ffa07a', label: 'Beach, Dune and Sand'},
  '24': {color: '#d4271e', label: 'Urban Area'},
  '25': {color: '#db4d4f', label: 'Other Non-Vegetated Area'},
  '27': {color: '#ffffff', label: 'Not Observed'},
  '29': {color: '#ffaa5f', label: 'Rocky Outcrop'},
  '30': {color: '#9c0027', label: 'Mining'},
  '31': {color: '#091077', label: 'Aquaculture'},
  '32': {color: '#fc8114', label: 'Hypersaline Tidal Flat'},
  '33': {color: '#2532e4', label: 'River, Lake or Ocean'},
  '34': {color: '#93dfe6', label: 'Glacier'},
  '35': {color: '#9065d0', label: 'Palm Oil'},
  '49': {color: '#02d659', label: 'Wooded Sand Vegetation'},
  '50': {color: '#ad5100', label: 'Herbaceous Sand Vegetation'},
  '68': {color: '#e97a7a', label: 'Other Natural Non-Vegetated Area'},
  '74': {color: '#be83f7', label: 'Banana (beta)'},
  '75': {color: '#c12100', label: 'Solar Panel Farm'},
  '81': {color: '#dfeb62', label: 'Andean Herbaceous and Shrubby Vegetation'},
  '82': {color: '#6fc179', label: 'Flooded Andean Herbaceous and Shrubby Vegetation'},
};
export const WLFW_CO_ISI_VALUE_MAP = {
  '1': {color: '#2c7bb6', label: 'Very Low'},
  '2': {color: '#abd9e9', label: 'Low'},
  '3': {color: '#ffffbf', label: 'Moderate'},
  '4': {color: '#fdae61', label: 'High'},
  '5': {color: '#d7191c', label: 'Severe'},
};
export const SBTN_NATURAL_LANDS_CLASSIFICATION_VALUE_MAP = {
  '0': {color: '#D3D3D3', label: 'Non-Natural'},
  '1': {color: '#a8ddb5', label: 'Natural'},
  '2': {color: '#246E24', label: 'Forests'},
  '3': {color: '#B9B91E', label: 'Short Vegetation'},
  '4': {color: '#6BAED6', label: 'Water'},
  '5': {color: '#06A285', label: 'Mangroves'},
  '6': {color: '#FEFECC', label: 'Bare Ground'},
  '7': {color: '#ACD1E8', label: 'Snow'},
  '8': {color: '#589558', label: 'Wetland Forests'},
  '9': {color: '#093D09', label: 'Peat Forests'},
  '10': {color: '#DBDB7B', label: 'Wetland Short Vegetation'},
  '11': {color: '#99991A', label: 'Peat Short Vegetation'},
};
export const SPACE_INTELLIGENCE_HABITAT_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#006200', label: 'Forest'},
  '2': {color: '#4f1209', label: 'Tree Farm'},
  '3': {color: '#e599c2', label: 'Vegetated Non-Forest'},
  '4': {color: '#499fd8', label: 'Water'},
  '5': {color: '#6d666b', label: 'Bare'},
  '6': {color: '#f9f62c', label: 'Agriculture & Pasture'},
  '7': {color: '#d47a2c', label: 'Plantation Tree Crops'},
  '8': {color: '#1f645c', label: 'Mangrove Forest'},
};
export const SPACE_INTELLIGENCE_HABITAT_URBAN_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '5': {color: '#1c1dff', label: 'Water'},
  '6': {color: '#747474', label: 'Bare/Paved/Developed'},
  '7': {color: '#e51f6e', label: 'Buildings'},
  '8': {color: '#007419', label: 'Wooded areas'},
  '9': {color: '#7bcd00', label: 'Non-wooded areas'},
  '10': {color: '#c4ac5d', label: 'Orchard'},
};
export const SPACE_INTELLIGENCE_HABITAT_10_CLASS_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#00300f', label: 'Dense Forest'},
  '2': {color: '#017e3b', label: 'Open Forest'},
  '3': {color: '#00aa7a', label: 'Mangrove Forest'},
  '4': {color: '#bb45bc', label: 'Forest Plantation'},
  '5': {color: '#ffc1ff', label: 'Tree Crops'},
  '6': {color: '#61592b', label: 'Shrub'},
  '7': {color: '#fffc8d', label: 'Grassland / Pasture'},
  '8': {color: '#f28f32', label: 'Agriculture'},
  '9': {color: '#8b8471', label: 'Urban / Bare'},
  '10': {color: '#1d60b8', label: 'Water'},
};
export const IMPACT_OBSERVATORY_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#419BDF', label: 'Water'},
  '2': {color: '#397D49', label: 'Trees'},
  '4': {color: '#7A87C6', label: 'Flooded Vegetation'},
  '5': {color: '#E49635', label: 'Crops'},
  '7': {color: '#C4281B', label: 'Built Area'},
  '8': {color: '#A59B8F', label: 'Bare Ground'},
  '9': {color: '#A8EBFF', label: 'Snow/Ice'},
  '10': {color: '#616161', label: 'Clouds'},
  '11': {color: '#E3E2C3', label: 'Rangeland'},
};
export const IMPACT_OBSERVATORY_HIGH_RES_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'No Data'},
  '1': {color: '#ffffff', label: 'Water Channel Extent'},
  '2': {color: '#bfdaf5', label: 'Variable Water'},
  '3': {color: '#25579d', label: 'Persistent Water'},
  '4': {color: '#005e24', label: 'Dense Trees'},
  '5': {color: '#aecca1', label: 'Sparse Trees'},
  '6': {color: '#a9a76a', label: 'Dense Rangeland'},
  '7': {color: '#f1e9b9', label: 'Sparse Rangeland'},
  '8': {color: '#7a87c6', label: 'Flooded Vegetation'},
  '9': {color: '#e49635', label: 'Crops'},
  '10': {color: '#67000d', label: 'High Density Built'},
  '11': {color: '#c44d45', label: 'Low Density Built'},
  '12': {color: '#a59b8f', label: 'Bare Ground'},
  '13': {color: '#a8ebff', label: 'Snow/Ice'},
  '14': {color: '#616161', label: 'Clouds'},
};
export const CHLORIS_FOREST_VALUE_MAP = {
  '0': {color: '#c1ada8', label: 'Non-Forest'},
  '1': {color: '#227c27', label: 'Forest'},
};
export const CDL_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'Background'},
  '1': {color: '#ffd400', label: 'Corn'},
  '2': {color: '#ff2626', label: 'Cotton'},
  '3': {color: '#00a9e6', label: 'Rice'},
  '4': {color: '#ff9e0f', label: 'Sorghum'},
  '5': {color: '#267300', label: 'Soybeans'},
  '6': {color: '#ffff00', label: 'Sunflower'},
  '10': {color: '#70a800', label: 'Peanuts'},
  '11': {color: '#00af4d', label: 'Tobacco'},
  '12': {color: '#e0a60f', label: 'Sweet Corn'},
  '13': {color: '#e0a60f', label: 'Pop or Orn Corn'},
  '14': {color: '#80d4ff', label: 'Mint'},
  '21': {color: '#e2007f', label: 'Barley'},
  '22': {color: '#8a6453', label: 'Durum Wheat'},
  '23': {color: '#d9b56c', label: 'Spring Wheat'},
  '24': {color: '#a87000', label: 'Winter Wheat'},
  '25': {color: '#d69dbc', label: 'Other Small Grains'},
  '26': {color: '#737300', label: 'Dbl Crop WinWht/Soybeans'},
  '27': {color: '#ae017e', label: 'Rye'},
  '28': {color: '#a15889', label: 'Oats'},
  '29': {color: '#73004c', label: 'Millet'},
  '30': {color: '#d69dbc', label: 'Speltz'},
  '31': {color: '#d1ff00', label: 'Canola'},
  '32': {color: '#8099ff', label: 'Flaxseed'},
  '33': {color: '#d6d600', label: 'Safflower'},
  '34': {color: '#d1ff00', label: 'Rape Seed'},
  '35': {color: '#00af4d', label: 'Mustard'},
  '36': {color: '#ffa8e3', label: 'Alfalfa'},
  '37': {color: '#a5f58d', label: 'Other Hay/Non Alfalfa'},
  '38': {color: '#00af4d', label: 'Camelina'},
  '39': {color: '#d69dbc', label: 'Buckwheat'},
  '41': {color: '#a900e6', label: 'Sugarbeets'},
  '42': {color: '#a80000', label: 'Dry Beans'},
  '43': {color: '#732600', label: 'Potatoes'},
  '44': {color: '#00af4d', label: 'Other Crops'},
  '45': {color: '#b380ff', label: 'Sugarcane'},
  '46': {color: '#732600', label: 'Sweet Potatoes'},
  '47': {color: '#ff6666', label: 'Misc Vegs & Fruits'},
  '48': {color: '#ff6666', label: 'Watermelons'},
  '49': {color: '#ffcc66', label: 'Onions'},
  '50': {color: '#ff6666', label: 'Cucumbers'},
  '51': {color: '#00af4d', label: 'Chick Peas'},
  '52': {color: '#00deb0', label: 'Lentils'},
  '53': {color: '#55ff00', label: 'Peas'},
  '54': {color: '#f5a27a', label: 'Tomatoes'},
  '55': {color: '#ff6666', label: 'Caneberries'},
  '56': {color: '#00af4d', label: 'Hops'},
  '57': {color: '#80d4ff', label: 'Herbs'},
  '58': {color: '#e8beff', label: 'Clover/Wildflowers'},
  '59': {color: '#b2ffde', label: 'Sod/Grass Seed'},
  '60': {color: '#00af4d', label: 'Switchgrass'},
  '61': {color: '#bfbf7a', label: 'Fallow/Idle Cropland'},
  '63': {color: '#95ce93', label: 'Forest'},
  '64': {color: '#c7d79e', label: 'Shrubland'},
  '65': {color: '#ccbfa3', label: 'Barren'},
  '66': {color: '#ff00ff', label: 'Cherries'},
  '67': {color: '#ff91ab', label: 'Peaches'},
  '68': {color: '#b90050', label: 'Apples'},
  '69': {color: '#704489', label: 'Grapes'},
  '70': {color: '#007878', label: 'Christmas Trees'},
  '71': {color: '#b39c70', label: 'Other Tree Crops'},
  '72': {color: '#ffff80', label: 'Citrus'},
  '74': {color: '#b6705c', label: 'Pecans'},
  '75': {color: '#00a884', label: 'Almonds'},
  '76': {color: '#ebd6b0', label: 'Walnuts'},
  '77': {color: '#b39c70', label: 'Pears'},
  '81': {color: '#f7f7f7', label: 'Clouds/No Data'},
  '82': {color: '#9c9c9c', label: 'Developed'},
  '83': {color: '#4d70a3', label: 'Water'},
  '87': {color: '#80b3b3', label: 'Wetlands'},
  '88': {color: '#e9ffbe', label: 'Nonag/Undefined'},
  '92': {color: '#00ffff', label: 'Aquaculture'},
  '111': {color: '#4d70a3', label: 'Open Water'},
  '112': {color: '#d4e3fc', label: 'Perennial Ice/Snow'},
  '121': {color: '#9c9c9c', label: 'Developed/Open Space'},
  '122': {color: '#9c9c9c', label: 'Developed/Low Intensity'},
  '123': {color: '#9c9c9c', label: 'Developed/Med Intensity'},
  '124': {color: '#9c9c9c', label: 'Developed/High Intensity'},
  '131': {color: '#ccbfa3', label: 'Barren'},
  '141': {color: '#95ce93', label: 'Deciduous Forest'},
  '142': {color: '#95ce93', label: 'Evergreen Forest'},
  '143': {color: '#95ce93', label: 'Mixed Forest'},
  '152': {color: '#c7d79e', label: 'Shrubland'},
  '176': {color: '#e9ffbe', label: 'Grass/Pasture'},
  '190': {color: '#80b3b3', label: 'Woody Wetlands'},
  '195': {color: '#80b3b3', label: 'Herbaceous Wetlands'},
  '204': {color: '#00ff8c', label: 'Pistachios'},
  '205': {color: '#d69dbc', label: 'Triticale'},
  '206': {color: '#ff6666', label: 'Carrots'},
  '207': {color: '#ff6666', label: 'Asparagus'},
  '208': {color: '#ff6666', label: 'Garlic'},
  '209': {color: '#ff6666', label: 'Cantaloupes'},
  '210': {color: '#ff91ab', label: 'Prunes'},
  '211': {color: '#344a34', label: 'Olives'},
  '212': {color: '#e67525', label: 'Oranges'},
  '213': {color: '#ff6666', label: 'Honeydew Melons'},
  '214': {color: '#ff6666', label: 'Broccoli'},
  '215': {color: '#66994d', label: 'Avocados'},
  '216': {color: '#ff6666', label: 'Peppers'},
  '217': {color: '#b39c70', label: 'Pomegranates'},
  '218': {color: '#ff91ab', label: 'Nectarines'},
  '219': {color: '#ff6666', label: 'Greens'},
  '220': {color: '#ff91ab', label: 'Plums'},
  '221': {color: '#ff6666', label: 'Strawberries'},
  '222': {color: '#ff6666', label: 'Squash'},
  '223': {color: '#ff91ab', label: 'Apricots'},
  '224': {color: '#00af4d', label: 'Vetch'},
  '225': {color: '#ffd400', label: 'Dbl Crop WinWht/Corn'},
  '226': {color: '#ffd400', label: 'Dbl Crop Oats/Corn'},
  '227': {color: '#ff6666', label: 'Lettuce'},
  '228': {color: '#ffd400', label: 'Dbl Crop Triticale/Corn'},
  '229': {color: '#ff6666', label: 'Pumpkins'},
  '230': {color: '#8a6453', label: 'Dbl Crop Lettuce/Durum Wht'},
  '231': {color: '#ff6666', label: 'Dbl Crop Lettuce/Cantaloupe'},
  '232': {color: '#ff2626', label: 'Dbl Crop Lettuce/Cotton'},
  '233': {color: '#e2007f', label: 'Dbl Crop Lettuce/Barley'},
  '234': {color: '#ff9e0f', label: 'Dbl Crop Durum Wht/Sorghum'},
  '235': {color: '#ff9e0f', label: 'Dbl Crop Barley/Sorghum'},
  '236': {color: '#a87000', label: 'Dbl Crop WinWht/Sorghum'},
  '237': {color: '#ffd400', label: 'Dbl Crop Barley/Corn'},
  '238': {color: '#a87000', label: 'Dbl Crop WinWht/Cotton'},
  '239': {color: '#267300', label: 'Dbl Crop Soybeans/Cotton'},
  '240': {color: '#267300', label: 'Dbl Crop Soybeans/Oats'},
  '241': {color: '#ffd400', label: 'Dbl Crop Corn/Soybeans'},
  '242': {color: '#000099', label: 'Blueberries'},
  '243': {color: '#ff6666', label: 'Cabbage'},
  '244': {color: '#ff6666', label: 'Cauliflower'},
  '245': {color: '#ff6666', label: 'Celery'},
  '246': {color: '#ff6666', label: 'Radishes'},
  '247': {color: '#ff6666', label: 'Turnips'},
  '248': {color: '#ff6666', label: 'Eggplants'},
  '249': {color: '#ff6666', label: 'Gourds'},
  '250': {color: '#ff6666', label: 'Cranberries'},
  '254': {color: '#267300', label: 'Dbl Crop Barley/Soybeans'},
  '255': {color: '#000000', label: 'No Data'},
};
export const WRI_GLOBAL_GRASSLAND_PASTURE_LANDCOVER_VALUE_MAP = {
  '0': {color: '#ffffff', label: 'Other'},
  '1': {color: '#ffcd73', label: 'Cultivated grassland'},
  '2': {color: '#ff9916', label: 'Natural/Semi-natural grassland'},
  '3': {color: '#a88b4b', label: 'Open shrubland'},
};
export const GNATSGO_SOILTYPE_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data', extendedLabel: 'No data'},
  '1': {
    color: '#a1d99b',
    label: 'A',
    extendedDescription:
      'Group A (High Infiltration / Low Runoff): These soils consist primarily of deep, well-drained to excessively drained sands or gravelly sands. They have a high rate of water transmission, meaning water moves through them quickly even when saturated.',
  },
  '2': {
    color: '#ffea46',
    label: 'B',
    extendedDescription:
      'Group B (Moderate Infiltration): Consisting of moderately deep to deep soils with moderately fine to moderately coarse textures (like silt loam or loam), these soils have a moderate rate of water transmission and infiltration.',
  },
  '3': {
    color: '#f16913',
    label: 'C',
    extendedDescription:
      'Group C (Slow Infiltration): These soils typically have a layer that impedes the downward movement of water or have a moderately fine to fine texture (like sandy clay loam). This results in a slow rate of water transmission and higher runoff potential.',
  },
  '4': {
    color: '#3f2923',
    label: 'D',
    extendedDescription:
      'Group D (Very Slow Infiltration / High Runoff): These soils have the highest runoff potential. They are often clay-based with high swelling potential, have a permanent high water table, or are shallow soils sitting over nearly impervious material. Water moves through these very slowly.',
  },
  '5': {
    color: '#1b4332',
    label: 'A/D',
    extendedDescription:
      'Group A/D: These soils naturally have very slow infiltration due to a high water table, but offer high infiltration and low runoff if drained.',
  },
  '6': {
    color: '#9c820f',
    label: 'B/D',
    extendedDescription:
      'Group B/D: These soils naturally have very slow infiltration, but achieve a moderate infiltration rate if drained.',
  },
  '7': {
    color: '#8b0000',
    label: 'C/D',
    extendedDescription:
      'Group C/D: These soils naturally have very slow infiltration, but will have a slow (though improved) infiltration rate if drained.',
  },
};
export const GRASSLANDS_RISK_VALUE_MAP = {
  '5': {color: '#55601c', label: 'Core Grasslands'},
  '7': {color: '#efeee9', label: 'Desert / Shrubland'},
  '100': {color: '#fcd900', label: 'Vulnerable Grasslands'},
  '500': {color: '#53284f', label: 'Converted / Altered Grasslands'},
  '1000': {color: '#000000', label: 'Forest'},
  '2000': {color: '#e60000', label: 'Developed'},
  '5000': {color: '#35618f', label: 'Water'},
};
export const DASHBOARD_ERRORS = {NO_STATISTICS_FOUND: 'No statistics found'};
export const UPLOAD_PROBLEMS = '__UPSTREAM_PROBLEMS';
export const UPLOAD_WARNINGS = '__UPSTREAM_WARNINGS';
export const MAX_AREA_ACRES = 500000;
export const UPLOAD_ERROR_CONSTANTS = {
  FILE_TOO_LARGE: {
    text: 'File size is too large',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#size',
    label: 'File too large',
  },
  UNSUPPORTED_FILE_TYPE: {
    text: 'must provide file as a zipped shapefile (.zip), .kml, .kmz or .geojson',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#file',
    label: 'Unsupported file type',
  },
  NO_POLYGONAL_GEOMETRY: {
    text: 'No polygonal geometry found (lines and points are not supported).',
    supportUrl:
      'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#polygonal',
    label: 'No polygonal geometry',
  },
  DUPLICATE_FEATURES: {
    text: 'Duplicate features found',
    supportUrl:
      'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#duplicate',
    label: 'Duplicate features',
  },
  TOO_MANY_FEATURES: {
    text: 'Too many features provided',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#many',
    label: 'Too many features',
  },
  TOO_MANY_COORDINATES: {
    text: 'Feature has too many coordinates',
    supportUrl:
      'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#coordinates',
    label: 'Feature too many coordinates',
  },
  INVALID_FEATURE_GEOMETRY: {
    text: 'Feature geometry is not valid',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#invalid',
    label: 'Invalid feature geometry',
  },
  FEATURE_IN_WARNING_AOI: {
    text: 'This property is in a region where imagery requests may go through an extra step of approval — our team will be in touch if needed.',
    supportUrl: '',
    label: 'Feature in warning aoi',
  },
  TOO_SMALL_AREA: {
    text: 'Feature area is too small',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#small',
    label: 'Feature too small',
  },
  TOO_LARGE_AREA: {
    text: 'Feature area is too large',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#large',
    label: 'Feature too large',
  },
  TOO_SPREAD_OUT: {
    text: 'Feature area is too spread out',
    supportUrl: 'https://lens.tech/support/article/147-preparing-geospatial-data-for-lens#spread',
    label: 'Feature too spread out',
  },
  NO_MATCHED_FEATURES: {
    text: 'No matched features were found in this file',
    supportUrl: 'https://lens.tech/support/article/74-updating-properties',
    label: 'No updates found',
  },
};
export const LENS_APP_PROD_URL = 'https://app.lens.tech';
export const LENS_APP_LEGACY_URL = 'https://app.upstream.tech';
export const LENS_APP_STAGING_URL_PREFIX = 'https://monitron-dev--';
export const LENS_APP_DEV_URL = 'http://localhost:9999';
export const LOGIN_APP_PROD_URL = 'https://login.upstream.tech';
export const LOGIN_APP_STAGING_URL_PREFIX = 'https://login-app-web-upstream--';
export const LOGIN_APP_DEV_URL = 'http://localhost:3001';
export const HYDROFORECAST_APP_PROD_URL = 'https://dashboard.hydroforecast.com';
export const HYDROFORECAST_APP_STAGING_URL_PREFIX = 'https://hydroforecast-web--';
export const HYDROFORECAST_APP_DEV_URL = 'http://localhost:3000';
export const API_PROD_URL = 'https://api.upstream.tech';
export const API_DEV_URL = 'http://localhost:8080';
export const SERIES_PROCESSOR_IDS_TO_INIT_TIME_OFFSET_MINUTES = {
  'ecmwf-hres': 450,
  gefs: 390,
  gfs: 315,
  hrrr: 90,
};
